// PATCHED COPY of sue-beta/v1.3/cart-checkout.js for the Shopify theme checkout.
// Generated by shopify-theme/checkout/patch_cart_checkout.py; edit the original, then re-run.
// Expects window.VP_API_BASE (checkout Worker origin). // [vp-theme-checkout patch v1]
// ─── CART / CHECKOUT ──────────────────────────────────────────────────────────
//
// Extracted from configurator.html's inline script (Phase 5 split). Loaded via
// <script src> at the exact document position this code used to occupy inline,
// so execution order relative to the rest of configurator.html is unchanged.
//
// Depends on globals declared earlier in configurator.html's own script:
// cartItems, cartCount, currentOrderRef, artworkFile, artworkDataUrl,
// artworkOriginalDataUrl, lidArtworkDataUrl, lidArtworkOriginalDataUrl,
// CATEGORIES, MATERIALS, SPECIALTY_LABELS, UPLOAD_LABEL_DEFAULT,
// currentCat, currentMat, currentPackageSize, currentSpecialty, currentFinish,
// currentProductImageUrl, ArtworkStore, jspdf (CDN), getNextOrderRef(),
// buildArtworkFilename(), loadPricing(), getSizeMult(), getMatMult(),
// vpGetProductType(), vpGetCurrentDims(), vpComputeTotal(), vpGetMultipliers(),
// vpQuoteSpec(), vpQuoteKey() (pricing-engine.js), getSelectedSizeLabel(),
// parseSizeString(), escHtml(),
// setPreviewHint(), setUploadTab(), setQty(), setSpecialtyFinish(),
// preview3D (preview-3d.js).

// ─── ADD TO CART ─────────────────────────────────────────────────────────────

// ─── SHOPIFY CART SIMULATION ─────────────────────────────────────────────────

var _cartEditing = null;
var _cartSaving = false;
var _cartCheckingOut = false;
var _cartLastItemId = 0;

function updateCartBusyState() {
  var busy = _cartSaving || _cartCheckingOut || !!(_cartEditing && _cartEditing.phase !== 'ready');
  var checkout = document.querySelector('.cart-btn-checkout');
  if (checkout) {
    checkout.disabled = busy || !!_cartEditing || isLocalCheckoutPreview() || cartHasNativeJarLabels();
    checkout.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
  updateCartButtonState();
}

function nextCartItemId() {
  // A retry must not reuse an ID still owned by a timed-out storage write.
  _cartLastItemId = cartItems.reduce(function(id, item) {
    return Math.max(id, Number(item.id) + 1 || 0);
  }, Math.max(Date.now(), _cartLastItemId + 1));
  return _cartLastItemId;
}

function removeStoredCartArtwork(id) {
  return Promise.resolve().then(function() { return ArtworkStore.remove(id); }).catch(function() {});
}

function saveCartArtwork(item) {
  return new Promise(function(resolve, reject) {
    var expired = false;
    var timer = setTimeout(function() {
      expired = true;
      removeStoredCartArtwork(item.id);
      reject(new Error('Artwork storage did not respond in time.'));
    }, 15000);
    Promise.resolve().then(function() {
      return ArtworkStore.save(
        item.id, item.artworkUrl, item.artworkOriginalUrl,
        item.lidArtworkUrl, item.lidArtworkOriginalUrl
      );
    }).then(function() {
      clearTimeout(timer);
      if (expired) {
        removeStoredCartArtwork(item.id);
        return;
      }
      resolve();
    }, function(err) {
      clearTimeout(timer);
      removeStoredCartArtwork(item.id);
      reject(err);
    });
  });
}

function addToCart() {
  if (_cartCheckingOut || _cartSaving || (_cartEditing && _cartEditing.phase !== 'ready')) return;
  if (_cartEditing && !cartEditMatchesProduct(_cartEditing)) {
    cancelCartEdit(true);
    cartEditNotice('Edit cancelled — the original item is still in your cart.');
    return;
  }
  var editing = _cartEditing;
  var cartAtSave = cartItems;
  // Button is disabled when required fields are missing — bail silently.
  var btn = document.querySelector('.btn-atc');
  if (btn && btn.disabled) return;

  // Command-priced products: display and charge share window._vpLastQuote.
  // No matching quote → do not guess Sue's formula.
  var spec = typeof vpQuoteSpec === 'function' ? vpQuoteSpec() : null;
  if (spec) {
    var quoted = window._vpLastQuote;
    if (!quoted || quoted.key !== vpQuoteKey(spec) || quoted.each == null || !isFinite(Number(quoted.each))) return;
  }

  var cat   = CATEGORIES[currentCat];
  var mat   = MATERIALS[currentMat];
  var printKind = typeof vpGetPrintKind === 'function' ? vpGetPrintKind() : null;
  var qty   = parseInt(document.getElementById('qtyInput').value, 10) || (printKind ? 1 : 50);

  // For packaging products the size comes from the selected package size;
  // for stickers/labels use the standard size selector.
  var size, packageSizeLabel = '';
  if (currentPackageSize) {
    packageSizeLabel = currentPackageSize.label;
    size = 'Side ' + currentPackageSize.sideW + '\u2033\xd7' + currentPackageSize.sideH + '\u2033' +
           (currentPackageSize.topW ? ' | Top ' + currentPackageSize.topW + '\u2033\xd7' + currentPackageSize.topH + '\u2033' : '');
  } else {
    var sizeText = getSelectedSizeLabel();
    size = sizeText === 'Custom'
      ? (document.getElementById('customW').value || '?') + '" \xd7 ' +
        (document.getElementById('customH').value || '?') + '" (custom)'
      : sizeText;
  }
  var spot  = currentSpecialty;
  var notes = document.getElementById('specialInstr').value || '';
  var rawArtwork = (artworkDataUrl || artworkOriginalDataUrl) && document.querySelector('#uploadZoneBody .upload-label strong')
                    ? document.querySelector('#uploadZoneBody .upload-label strong').textContent : '';

  // ── Order ref → structured artwork filename ───────────────────────────────
  // Simulates: GET /admin/api/2025-01/orders.json?limit=1&status=any&fields=order_number
  // In production, swap getNextOrderRef() for an authenticated Shopify API fetch.
  // One order ref is shared across ALL items in the cart session; generated only when cart is empty.
  if (cartItems.length === 0) currentOrderRef = getNextOrderRef();
  var orderRef = currentOrderRef;                               // e.g. "ORD-1043"
  var artworkExt = rawArtwork ? rawArtwork.split('.').pop().toLowerCase() : 'pdf';
  var datePart = (function(){
    var d = new Date(); var mm = String(d.getMonth()+1).padStart(2,'0');
    var dd = String(d.getDate()).padStart(2,'0'); return '' + d.getFullYear() + mm + dd;
  })();
  var uid = Math.random().toString(36).slice(2,6); // e.g. "a3f9" — prevents filename collisions
  // Filename prefix is now the order reference, not the customer name
  var fileFinish = vpMaterialLabel();
  if (printKind === 'posters') fileFinish = vpPrintFinishMeta().label;
  else if (printKind === 'yard-signs') fileFinish = (currentPrintSides === 'double' ? 'Double' : 'Single') + ' Satin';
  else if (printKind === 'banners') fileFinish = 'Unhemmed Grommets';
  artworkFile = rawArtwork
    ? buildArtworkFilename(orderRef, cat._customName || cat.name, fileFinish, size, qty, artworkExt, uid, datePart)
    : '(none)';

  // ── Compute price ────────────────────────────────────────────────────────
  // Must match updatePrice() (product-config.js): Command products charge
  // window._vpLastQuote (same each/total the screen showed); Sue products use
  // vpComputeTotal + vpGetMultipliers. Never mix the two.
  var unitPrice;
  var total;
  var unitFmt;
  if (printKind) {
    var pDims = vpGetCurrentDims();
    var printed = vpComputePrintTotal(printKind, pDims.w, pDims.h, qty);
    unitPrice = printed.each;
    total     = printed.total.toFixed(2);
    unitFmt   = unitPrice.toFixed(2);
  } else if (spec) {
    unitPrice = Number(window._vpLastQuote.each);
    var totNum = window._vpLastQuote.total != null
      ? Number(window._vpLastQuote.total)
      : (unitPrice * qty);
    total   = totNum.toFixed(2);
    unitFmt = unitPrice.toFixed(2);
  } else {
    var pricing     = loadPricing();
    var productType = vpGetProductType();
    var dims        = vpGetCurrentDims();
    var vpTotal     = vpComputeTotal(productType, dims.w, dims.h, qty);

    var mults      = vpGetMultipliers(pricing);
    var matMult    = mults.matMult;
    var finishMult = mults.finishMult;
    var spotMult   = mults.spotMult;
    var markup     = 1 + (pricing.markup || 0) / 100;

    if (vpTotal !== null) {
      unitPrice = (vpTotal / qty) * matMult * finishMult * spotMult * markup;
    } else {
      // Use getSizeMult so packaging products use the area power-law on side label dims
      var sizeMult = getSizeMult(pricing);
      var tiers    = pricing.tiers || [];
      var unitBase = 1.70;
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= tiers[i].qty) unitBase = tiers[i].unitPrice;
      }
      unitPrice = unitBase * sizeMult * matMult * finishMult * spotMult * markup;
    }
    total   = (Math.round(Number(unitPrice.toFixed(2)) * 100) * qty / 100).toFixed(2);  // = what Shopify charges
    unitFmt = unitPrice.toFixed(2);
  }

  // ── Product display name ─────────────────────────────────────────────────
  var productName = cat._customName || cat.name;

  // ── Build Shopify Draft Order payload ────────────────────────────────────
  // Order Ref is an order-level note_attribute (set in buildCheckoutPayload).
  // It is intentionally omitted from line item properties to avoid null/duplicate values.
  var properties;
  if (printKind) {
    if (printKind === 'yard-signs') size = '18" \xd7 24"';
    properties = [{ name: 'Product Type', value: productName }];
    if (printKind === 'posters') {
      properties.push({ name: 'Material', value: 'Satin poster' });
      properties.push({ name: 'Size', value: size });
      properties.push({ name: 'Finish', value: vpPrintFinishMeta().label });
    } else if (printKind === 'yard-signs') {
      properties.push({ name: 'Material', value: '4mm coroplast' });
      properties.push({ name: 'Size', value: size });
      properties.push({ name: 'Finish', value: 'Satin' });
      properties.push({ name: 'Sides', value: currentPrintSides === 'double' ? 'Double-sided' : 'Single-sided' });
      properties.push({ name: 'Stand', value: 'Metal stand included' });
    } else {
      properties.push({ name: 'Material', value: '13oz vinyl' });
      properties.push({ name: 'Size', value: size });
      properties.push({ name: 'Finish', value: 'Unhemmed · grommets' });
    }
    properties = properties.concat([
      { name: 'Artwork File',  value: artworkFile },
      { name: 'Preview Image', value: '[canvas PNG — see attached]' },
      { name: 'Unit Price',    value: '$' + unitFmt },
      { name: 'Special Notes', value: notes || '—' }
    ]);
  } else {
  properties = [
    { name: 'Product Type',   value: productName },
    { name: 'Material',       value: vpMaterialLabel() },
  ];
  if (packageSizeLabel) {
    properties.push({ name: 'Package Size', value: packageSizeLabel });
  }
  var finishProp = currentFinish.charAt(0).toUpperCase() + currentFinish.slice(1);
  if (spec && typeof vpQuoteFinish === 'function') {
    var qf = vpQuoteFinish();
    var FIN_LAB = { gloss: 'Gloss', matte: 'Matte', glitter: 'Glitter', holo: 'Holo', reflective: 'Reflective', chrome: 'Chrome', gold: 'Gold' };
    finishProp = FIN_LAB[qf] || finishProp;
  }
  var embossProp = (typeof EMBOSS_LABELS !== 'undefined' && EMBOSS_LABELS[currentEmboss])
    ? EMBOSS_LABELS[currentEmboss]
    : 'Flat';
  if (spec && typeof vpQuoteEmboss === 'function') {
    var qe = vpQuoteEmboss(spec.cut);
    embossProp = (typeof EMBOSS_LABELS !== 'undefined' && EMBOSS_LABELS[qe]) ? EMBOSS_LABELS[qe] : qe;
  }

  var hasEmboss = typeof vpQuoteEmboss === 'function' && vpQuoteEmboss() !== 'none';
  var laminateProp = hasEmboss ? 'None — embossed' : spot !== 'none'
    ? SPECIALTY_LABELS[spot] || spot : currentFinish === 'matte' ? 'Matte' : 'Gloss';
  if (hasEmboss) finishProp = 'Unlaminated';
  properties = properties.concat([
    { name: 'Size',           value: size },
    { name: 'Finish',         value: finishProp },
    { name: 'Laminate',       value: laminateProp },
    { name: 'Emboss',         value: embossProp },
    { name: 'Specialty Finish', value: spot === 'none' ? 'None' : SPECIALTY_LABELS[spot] || spot },
    { name: 'Artwork File',   value: artworkFile },
    { name: 'Preview Image',  value: '[canvas PNG — see attached]' },
    { name: 'Unit Price',     value: '$' + unitFmt },
    { name: 'Special Notes',  value: notes || '—' }
  ]);
  // Special instructions switch (Josh 10/17). The checkout server writes the same line (sue-pricing.js builderProperties).
  if (typeof vpEdgeCutOn === 'function' && vpEdgeCutOn()) {
    properties.splice(properties.findIndex(function(p) { return p.name === 'Artwork File'; }), 0, { name: 'Cut', value: EDGE_CUT_LABEL });
  }
  }

  var payload = {
    draft_order: {
      line_items: [{
        title:      productName,
        price:      unitFmt,
        quantity:   qty,
        requires_shipping: true,
        properties: properties
      }],
      note: 'VINYLPAC custom order — artwork and preview attached as order metafields.',
      note_attributes: [
        { name: 'artwork_filename', value: artworkFile }
      ],
      tags:  'custom-print, vinylpac-configurator',
      send_receipt: false
    }
  };

  // ── Grab images ──────────────────────────────────────────────────────────
  // Composited preview: export the active canvas if present, else product img
  // [vp-theme-checkout patch v1] Josh 10/12 (#4100's cart showed an empty grey thumbnail): the die-cut stage
  // is quote-3d.js's WebGL canvas (#sticker-3d, no preserveDrawingBuffer), which reads back blank outside a
  // frame. VPQuote3D.snapshot() draws a frame and reads it in the same task. A blank image is never kept:
  // the product photo below is used instead.
  var previewDataUrl = '';
  var activeCanvas   = document.querySelector('#preview3dWrap canvas');
  if (activeCanvas) {
    try {
      var stage3d = window.VPQuote3D;
      if (activeCanvas.id === 'sticker-3d') {
        previewDataUrl = stage3d && typeof stage3d.ready === 'function' && stage3d.ready() && typeof stage3d.snapshot === 'function'
          ? (stage3d.snapshot() || '') : '';
      } else {
        previewDataUrl = activeCanvas.toDataURL('image/png');
      }
      if (previewDataUrl && !vpCanvasHasPixels(activeCanvas)) previewDataUrl = '';
    } catch(e) { previewDataUrl = ''; }
  }
  if (!previewDataUrl) {
    // Fall back: draw the real product photo (not productImg.src, which may have
    // been overwritten by showArtworkPreview() for sticker categories)
    var realSrc = currentProductImageUrl
                  || CATEGORIES[currentCat].image
                  || '';
    if (realSrc) {
      try {
        // Use the already-loaded img element if src still matches; else create new
        var pImg = document.getElementById('productImg');
        var srcImg = (pImg && pImg.naturalWidth > 0 && pImg.src.indexOf('data:') === -1)
                     ? pImg : new Image();
        if (srcImg !== pImg) srcImg.src = realSrc;
        var oc = document.createElement('canvas');
        oc.width = 400; oc.height = 400;
        var octx = oc.getContext('2d');
        octx.fillStyle = '#f5f5f5';
        octx.fillRect(0, 0, 400, 400);
        if (srcImg.complete && srcImg.naturalWidth > 0) {
          octx.drawImage(srcImg, 0, 0, 400, 400);
        }
        previewDataUrl = oc.toDataURL('image/png');
      } catch(e) { previewDataUrl = realSrc; }
    }
  }

  // ── Small thumbnail for cart display (survives sessionStorage round-trip) ──
  var artworkThumb = '';
  if (artworkDataUrl) {
    try {
      var tImg = document.getElementById('uploadPreview');
      if (!tImg || !tImg.naturalWidth) { tImg = new Image(); tImg.src = artworkDataUrl; }
      if (tImg && tImg.naturalWidth > 0) {
        var tCanvas = document.createElement('canvas');
        var tMax = 100;
        var tScale = Math.min(1, tMax / tImg.naturalWidth, tMax / tImg.naturalHeight);
        tCanvas.width  = Math.round(tImg.naturalWidth  * tScale);
        tCanvas.height = Math.round(tImg.naturalHeight * tScale);
        tCanvas.getContext('2d').drawImage(tImg, 0, 0, tCanvas.width, tCanvas.height);
        artworkThumb = tCanvas.toDataURL('image/jpeg', 0.6);
      }
    } catch(e) {}
  }

    // ── Add to cart ─────────────────────────────────────────────────────────
  var newItem = {
    id:          nextCartItemId(),
    name:        productName,
    configuration: captureCartConfiguration(),
    qty:         qty,
    unitPrice:   unitFmt,
    total:       total,
    properties:  properties,
    previewUrl:  previewDataUrl,       // canvas data URL (in-memory only)
    cat:               currentCat,                        // category id for shipping lookup
    artworkUrl:         artworkDataUrl             || '', // body artwork PNG (preview, in-memory only)
    artworkThumb:       artworkThumb               || '', // small JPEG thumbnail — saved to sessionStorage
    artworkOriginalUrl: artworkOriginalDataUrl      || '', // original PDF if uploaded (Drive target)
    lidArtworkUrl:         lidArtworkDataUrl         || '', // lid artwork PNG (preview)
    lidArtworkOriginalUrl: lidArtworkOriginalDataUrl || '', // original lid PDF if uploaded
    artworkFile: artworkFile,
    thumbUrl:    currentProductImageUrl || CATEGORIES[currentCat].image || '',
    payload:     payload
  };
  // Bulk Order Form (Josh 10/17): a form design edited here stays one of the form's lines, so the order keeps its rush
  // and mockups answers (sessionStorage vp_cart_order) at checkout.
  var editedConfig = editing && editing.item && editing.item.configuration;
  if (editedConfig && editedConfig.bulkForm && newItem.configuration) {
    newItem.configuration.bulkForm = editedConfig.bulkForm;
    newItem.configuration.bulkRow = editedConfig.bulkRow;
  }
  // Reorder (Josh 10/25, reorder.js): an edited reordered design still says which past order and line it came from, so
  // the order keeps its "Reorder Of" marker and a second Reorder tap replaces it instead of adding a twin.
  // Only while the design is still the same design: new artwork or new specs (size, material, finish, laminate,
  // emboss, product) make it a fresh design, printed from its own art, proofed like any other (GPT Sol 10/25 r4).
  // Quantity and notes may change.
  if (editedConfig && editedConfig.reorderOf && newItem.configuration) {
    var sameSpec = cartReorderSpec(editedConfig) === cartReorderSpec(newItem.configuration) &&
      (currentCat !== 'posters' || cartPrintProps(editing.item.properties) === cartPrintProps(newItem.properties));
    var sameArt = cartArtSame(editing.artSig, cartArtSig());
    if (sameSpec && sameArt) {
      newItem.configuration.reorderOf = editedConfig.reorderOf;
      newItem.configuration.reorderLine = editedConfig.reorderLine;
      newItem.configuration.reorderName = editedConfig.reorderName;
    }
  }
  // Commit only after full artwork is durable; never overwrite the original on failure.
  var committed = false;
  _cartSaving = true;
  if (editing) editing.phase = 'saving';
  if (btn) btn.disabled = true;
  return Promise.resolve().then(function() {
    updateCartBusyState();
    return saveCartArtwork(newItem);
  }).then(function() {
    var idx = editing ? cartItems.indexOf(editing.item) : -1;
    if (_cartCheckingOut || (!editing && cartItems !== cartAtSave) || (editing && (_cartEditing !== editing || idx < 0 || !cartEditMatchesProduct(editing)))) {
      removeStoredCartArtwork(newItem.id);
      if (editing && _cartEditing === editing) cancelCartEdit(true);
      cartEditNotice('Save cancelled because the cart or product changed. No item was added or replaced.');
      return false;
    }
    if (editing) cartItems.splice(idx, 1, newItem);
    else cartItems.push(newItem);
    if (!saveCart()) {
      if (editing) cartItems.splice(idx, 1, editing.item);
      else cartItems.splice(cartItems.indexOf(newItem), 1);
      removeStoredCartArtwork(newItem.id);
      throw new Error('Cart storage is full or unavailable.');
    }
    committed = true;
    cartCount = cartItems.length;
    try { if (window.VPArtUpload) window.VPArtUpload.added(newItem.id, newItem, newItem.configuration); } catch (e) {} // [vp-theme-checkout patch v1] art up now (vp-art.js, Josh 10/18)
    if (editing) {
      cancelCartEdit(true);
      removeStoredCartArtwork(editing.item.id);
    }
    updateCartBadge();
    renderCartDrawer();
    // Josh 10/29 (funnel item 4): the first design added opens the cart, so the buyer sees it and Continue to
    // payment; later adds keep the toast.
    if (!editing && cartItems.length === 1) openCartDrawer();
    else cartEditNotice(qty + '× ' + productName + (editing ? ' updated!' : ' added!'));
    // Do not clear a different upload selected while IndexedDB was saving.
    // Josh 10/15: size/qty/material/laminate stay; artwork + notes/white-ink areas clear.
    if ((artworkDataUrl || '') === newItem.artworkUrl && (lidArtworkDataUrl || '') === newItem.lidArtworkUrl) {
      if (typeof vpClearPerOrderInputs === 'function') vpClearPerOrderInputs(notes); else resetArtwork();
    }
    return true;
  }).catch(function(err) {
    if (committed) {
      console.warn('[Cart] display refresh failed:', err);
      cartEditNotice('Your cart was saved, but the preview could not refresh. Reopen the cart to check it.');
      return true;
    }
    if (editing && _cartEditing === editing) editing.phase = 'ready';
    console.warn('[Cart] save failed:', err);
    cartEditNotice('Could not save: ' + (err && err.message ? err.message : 'Artwork storage failed.') + ' Your artwork and original cart are unchanged. Please try again.');
    return false;
  }).finally(function() {
    _cartSaving = false;
    updateCartBusyState();
  });
}

function resetArtwork() {
  // Clear file input so the same file can be re-selected fresh
  var fi = document.getElementById('fileInput');
  try { fi.value = ''; } catch(e) { fi.type='text'; fi.type='file'; }

  // Reset upload zone label + thumbnail
  document.querySelector('.upload-label').innerHTML = UPLOAD_LABEL_DEFAULT;
  var prev = document.getElementById('uploadPreview');
  prev.src = ''; prev.style.display = 'none';

  // Clear sticker overlay
  var overlay = document.getElementById('artworkOverlay');
  if (overlay) overlay.innerHTML = '';

  // Clear 3D compositor canvas
  if (typeof preview3D !== 'undefined' && preview3D) {
    preview3D.deactivate();
  }
  // Also clear the wrap directly in case deactivate didn't fire
  var wrap = document.getElementById('preview3dWrap');
  if (wrap) { wrap.style.display = 'none'; wrap.innerHTML = ''; }

  // Restore plain product image (in case compositor replaced it)
  var productImg = document.getElementById('productImg');
  if (productImg && currentProductImageUrl) {
    productImg.src = currentProductImageUrl;
    productImg.style.opacity = '1';
  }

  // Clear global artwork state
  setPreviewHint(true);
  artworkDataUrl            = null;
  artworkOriginalDataUrl    = null;
  lidArtworkDataUrl         = null;
  lidArtworkOriginalDataUrl = null;
  artworkFile               = '(none)';

  // Clear lid upload zone
  var lidPrev = document.getElementById('uploadPreviewLid');
  if (lidPrev) { lidPrev.src = ''; lidPrev.style.display = 'none'; }
  var lidLabel = document.getElementById('lidUploadLabel');
  if (lidLabel) lidLabel.innerHTML = '<strong>Upload Lid Artwork</strong>';
  var lidInput = document.getElementById('fileInputLid');
  if (lidInput) { try { lidInput.value = ''; } catch(e) { lidInput.type='text'; lidInput.type='file'; } }

  // Reset to body tab
  setUploadTab('body');

  // Hide print download button
  var dlBtn = document.getElementById('printDlBtn');
  if (dlBtn) dlBtn.classList.remove('visible');
  if (window.vpStickerPreview) window.vpStickerPreview.sync();
}

// ─── PRINT FILE EXPORT ───────────────────────────────────────────────────────

// parseSizeString — pure version in vinylpac-utils.js
// DOM wrapper used by downloadPrintFile():
function parseSizeInches() {
  // For packaging products, use the side label dimensions directly
  if (currentPackageSize) {
    return { w: currentPackageSize.sideW || 3, h: currentPackageSize.sideH || 3 };
  }
  var sizeText = getSelectedSizeLabel();
  var customW = document.getElementById('customW') ? document.getElementById('customW').value : 3;
  var customH = document.getElementById('customH') ? document.getElementById('customH').value : 3;
  return parseSizeString(sizeText, customW, customH);
}

function downloadPrintFile() {
  // 10/12: jsPDF loads on first use (vp-lazy.js), not with the page.
  if (typeof jspdf === 'undefined' && window.vpLazy) {
    window.vpLazy('jspdf').then(function () { downloadPrintFile(); }, function () {});
    return;
  }
  if (!artworkDataUrl) { alert('Please upload artwork first.'); return; }

  var sz     = parseSizeInches();
  var wIn    = sz.w;
  var hIn    = sz.h;
  var bleed  = 0.125;   // 1/8" bleed on all sides
  var safe   = 0.125;   // 1/8" safe zone inside trim (drawn as guide, not enforced)
  var gap    = 0.0625;  // space between trim edge and start of crop mark
  var mLen   = 0.25;    // length of each crop mark line
  var margin = gap + mLen; // space outside bleed for crop marks

  // Total PDF canvas size
  var pdfW = wIn + 2 * bleed + 2 * margin;
  var pdfH = hIn + 2 * bleed + 2 * margin;

  var doc = new jspdf.jsPDF({
    orientation: wIn >= hIn ? 'landscape' : 'portrait',
    unit: 'in',
    format: [pdfW, pdfH]
  });

  // ── Artwork image (fills trim + bleed area) ─────────────────────────────
  var imgX = margin;            // left edge of bleed area
  var imgY = margin;            // top edge of bleed area
  var imgW = wIn + 2 * bleed;
  var imgH = hIn + 2 * bleed;

  // Detect image type
  var imgType = 'PNG';
  if (artworkDataUrl.indexOf('data:image/jpeg') === 0) imgType = 'JPEG';
  doc.addImage(artworkDataUrl, imgType, imgX, imgY, imgW, imgH);

  // ── Trim line coordinates ───────────────────────────────────────────────
  var tx1 = margin + bleed;          // left trim
  var tx2 = tx1 + wIn;               // right trim
  var ty1 = margin + bleed;          // top trim
  var ty2 = ty1 + hIn;               // bottom trim

  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.004);

  // Corner crop marks — 4 corners × 2 lines each
  var corners = [
    // [x1,y1,x2,y2] for horizontal, [x1,y1,x2,y2] for vertical
    // Top-left
    [[tx1 - gap - mLen, ty1, tx1 - gap, ty1], [tx1, ty1 - gap - mLen, tx1, ty1 - gap]],
    // Top-right
    [[tx2 + gap, ty1, tx2 + gap + mLen, ty1], [tx2, ty1 - gap - mLen, tx2, ty1 - gap]],
    // Bottom-left
    [[tx1 - gap - mLen, ty2, tx1 - gap, ty2], [tx1, ty2 + gap, tx1, ty2 + gap + mLen]],
    // Bottom-right
    [[tx2 + gap, ty2, tx2 + gap + mLen, ty2], [tx2, ty2 + gap, tx2, ty2 + gap + mLen]]
  ];
  corners.forEach(function(c) {
    doc.line(c[0][0], c[0][1], c[0][2], c[0][3]);
    doc.line(c[1][0], c[1][1], c[1][2], c[1][3]);
  });

  // ── Labels ──────────────────────────────────────────────────────────────
  doc.setFontSize(6);
  doc.setTextColor(120);
  var cat  = CATEGORIES[currentCat];
  var mat  = MATERIALS[currentMat];
  var prod = cat._customName || cat.name;
  doc.text(
    'VINYLPAC  |  ' + prod + '  |  ' + vpMaterialLabel() + '  |  ' +
    wIn + '\u2033 \xd7 ' + hIn + '\u2033  |  Bleed: 1/8"  |  Safe zone: 1/8" inside trim',
    pdfW / 2, pdfH - 0.04,
    { align: 'center' }
  );

  // ── Safe zone guide (dashed, light grey) ────────────────────────────────
  doc.setDrawColor(180);
  doc.setLineWidth(0.003);
  doc.setLineDashPattern([0.04, 0.04], 0);
  doc.rect(tx1 + safe, ty1 + safe, wIn - 2 * safe, hIn - 2 * safe);
  doc.setLineDashPattern([], 0);

  // ── Save ────────────────────────────────────────────────────────────────
  var base = artworkFile && artworkFile !== '(none)'
    ? artworkFile.replace(/\.[^.]+$/, '')
    : 'vinylpac-artwork';
  doc.save(base + '_PRINT.pdf');
}

// escHtml — defined in vinylpac-utils.js

function syntaxHighlight(json) {
  json = json.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function(match) {
      var cls = 'j-num';
      if (/^"/.test(match)) {
        cls = /:$/.test(match) ? 'j-key' : 'j-str';
      } else if (/true|false/.test(match)) {
        cls = 'j-bool';
      } else if (/null/.test(match)) {
        cls = 'j-null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    }
  );
}

// ─── CART DRAWER ─────────────────────────────────────────────────────────────

function captureCartConfiguration() {
  function value(id) { var el = document.getElementById(id); return el ? el.value : ''; }
  function filename(selector) { var el = document.querySelector(selector); return el ? el.textContent : ''; }
  var pkg = currentPackageSize;
  var dims = vpGetCurrentDims();
  return {
    version: 1,
    cat: currentCat,
    chipId: currentChipId,
    productName: CATEGORIES[currentCat]._customName || CATEGORIES[currentCat].name,
    nav: getNavContext(),
    sizeLabel: getSelectedSizeLabel(),
    width: dims.w, height: dims.h,
    customW: value('customW'), customH: value('customH'),
    qty: parseInt(value('qtyInput'), 10),
    materialId: MATERIALS[currentMat].id,
    finish: currentFinish,
    specialty: currentSpecialty,
    emboss: currentEmboss,
    underlay: currentUnderlay,
    packageSize: pkg ? { id: pkg.id, label: pkg.label, sideW: pkg.sideW, sideH: pkg.sideH, topW: pkg.topW || 0, topH: pkg.topH || 0 } : null,
    jarColor: currentJarColor,
    uploadTab: currentUploadTab,
    bodyFilename: (artworkDataUrl || artworkOriginalDataUrl) ? filename('#uploadZoneBody .upload-label strong') : '',
    lidFilename: filename('#lidUploadLabel strong'),
    notes: value('specialInstr'),
    edgeCut: typeof vpEdgeCutOn === 'function' && vpEdgeCutOn(),
    artwork: {
      body: !!artworkDataUrl, bodyOriginal: !!artworkOriginalDataUrl,
      lid: !!lidArtworkDataUrl, lidOriginal: !!lidArtworkOriginalDataUrl
    }
  };
}

function cartProductCatalog() {
  var chips = [];
  Object.keys(SWITCHER_GROUPS).forEach(function(key) {
    chips = chips.concat(SWITCHER_GROUPS[key] || []);
  });
  (loadPackagingConfig().products || []).forEach(function(prod) {
    var meta = PACKAGING_PRODUCT_META[prod.name] || {};
    chips.push({ id: prod.id, name: prod.name, label: prod.name, cat: meta.cat || 'packaging', nav: meta.nav || 'packaging', img: meta.img || PACKAGING_FALLBACK_IMG });
  });
  return chips;
}

function cartItemIsNativeJarLabels(item) {
  return item.cat === 'jar-labels' || !!(item.configuration && item.configuration.kind === 'jar-labels');
}

function cartHasNativeJarLabels() { // [vp-theme-checkout patch v1] jar labels check out through the Worker (10/16)
  return false;
}

function cartItemIsJarCase(item) {
  if (cartItemIsNativeJarLabels(item)) return false;
  if (item.cat === 'jars' || (item.configuration && item.configuration.kind === 'jars')) return true;
  if (item.cat || item.configuration) return false;
  // Older saveCart versions dropped cat even for inventory cases.
  return (item.properties || []).some(function(p) {
    return p.name === 'Preview Image' && p.value === '(product photo — no custom artwork)';
  }) && (item.properties || []).some(function(p) {
    return p.name === 'Size' && /jars\//.test(p.value);
  });
}

function cartItemConfiguration(item) {
  if (item.configuration && item.configuration.version === 1) return item.configuration;
  var props = {};
  (item.properties || []).forEach(function(p) { props[p.name] = p.value; });
  var name = props['Product Type'] || item.name;
  var chip = cartProductCatalog().find(function(c) { return c.name === name || c.label === name; });
  var cat = item.cat || (chip && chip.cat) || Object.keys(CATEGORIES).find(function(key) { return CATEGORIES[key].name === name; });
  var mat = MATERIALS.find(function(m) { return m.label === props.Material; });
  var finish = String(props.Finish || '').toLowerCase();
  if (!mat) {
    var matId = { mirror: 'chrome', holographic: 'holo' }[finish] || finish;
    mat = MATERIALS.find(function(m) { return m.id === matId; });
  }
  var sf = String(props['Specialty Finish'] || '').toLowerCase();
  var specialty = Object.keys(SPECIALTY_LABELS).find(function(key) { return SPECIALTY_LABELS[key].toLowerCase() === sf; });
  if (!specialty && typeof SPECIALTY_LEGACY_LABELS === 'object') specialty = SPECIALTY_LEGACY_LABELS[sf];
  var size = String(props.Size || '');
  var dims = size.match(/([\d.]+)\s*["″']?\s*[×x]\s*([\d.]+)/i);
  var printChip = chip && (chip.id === 'posters' || chip.id === 'yard-signs' || chip.id === 'banners');
  var printFinish = null;
  if (props.Finish === 'Spot Holo') printFinish = 'spot-holo';
  else if (props.Finish === 'Holographic') printFinish = 'holo';
  else if (props.Finish === 'Satin') printFinish = 'satin';
  else if (/unhemmed/i.test(String(props.Finish || ''))) printFinish = 'unhemmed-grommets';
  var bannerFeet = size.match(/([\d.]+)\s*'\s*[×x]\s*([\d.]+)/i);
  if (printChip && chip.id === 'banners' && bannerFeet) {
    dims = [null, String(Number(bannerFeet[1]) * 12), String(Number(bannerFeet[2]) * 12)];
  }
  return {
    cat: cat, chipId: chip && chip.id, productName: name, nav: chip ? (chip.nav || chip.cat) : cat,
    sizeLabel: /custom/i.test(size) ? 'Custom' : size,
    width: dims ? Number(dims[1]) : null, height: dims ? Number(dims[2]) : null,
    customW: dims ? dims[1] : '', customH: dims ? dims[2] : '',
    qty: item.qty,
    materialId: printChip ? 'white-vinyl' : (mat ? mat.id : (CATEGORIES[cat] ? MATERIALS[CATEGORIES[cat].defaultMat || 0].id : null)),
    finish: finish === 'matte' ? 'matte' : 'glossy',
    printFinish: printFinish,
    printSides: /double/i.test(String(props.Sides || '')) ? 'double' : 'single',
    specialty: specialty || 'none',
    emboss: { flat: 'none', none: 'none', light: 'std', standard: 'std', std: 'std', heavy: 'heavy' }[String(props.Emboss || '').toLowerCase()] || 'none',
    packageSize: props['Package Size'] ? { label: props['Package Size'] } : null,
    bodyFilename: item.artworkFile || props['Artwork File'] || '',
    notes: props['Special Notes'] === '—' ? '' : (props['Special Notes'] || ''),
    edgeCut: /artwork edge/i.test(String(props.Cut || ''))
  };
}

function cartEditNotice(message) {
  var notif = document.getElementById('cartNotif');
  if (!notif) return;
  notif.textContent = message;
  notif.classList.add('show');
  clearTimeout(cartEditNotice.timer);
  cartEditNotice.timer = setTimeout(function() { notif.classList.remove('show'); }, 6000);
}

function cartEditMatchesProduct(editing) {
  return currentCat === editing.cat && currentChipId === editing.chipId &&
    (CATEGORIES[currentCat]._customName || CATEGORIES[currentCat].name) === editing.productName;
}

function cancelCartEdit(keepArtwork) {
  _cartEditing = null;
  var banner = document.getElementById('cartEditNotice');
  if (banner) banner.remove();
  var btn = document.querySelector('.btn-atc');
  if (btn && btn.dataset.cartAddLabel !== undefined) {
    btn.textContent = btn.dataset.cartAddLabel;
    delete btn.dataset.cartAddLabel;
  }
  if (!keepArtwork) {
    if (typeof vpClearPerOrderInputs === 'function') vpClearPerOrderInputs(); else resetArtwork();
    cartEditNotice('Edit cancelled — the original item is still in your cart.');
  }
  updateCartBusyState();
}

// Switching chips abandons an edit, not its original cart item.
document.addEventListener('click', function(e) {
  if (_cartEditing && e.target.closest && e.target.closest('.ps-chip')) cancelCartEdit(true);
}, true);

function restoreCartArtwork(item, config) {
  var fields = ['artworkUrl', 'artworkOriginalUrl', 'lidArtworkUrl', 'lidArtworkOriginalUrl', 'ringArtworkUrl', 'ringArtworkOriginalUrl'];
  function merge(record) {
    var art = {};
    fields.forEach(function(key) { art[key] = item[key] || (record && record[key]) || ''; });
    var expected = config.artwork || {};
    var filename = item.artworkFile || config.bodyFilename || '';
    if ((expected.body || (filename && filename !== '(none)') || item.artworkThumb) && !art.artworkUrl) {
      throw new Error('The full artwork is no longer available on this device.');
    }
    if ((expected.bodyOriginal || cartNeedsOriginal(filename)) && !art.artworkOriginalUrl) {
      throw new Error('The original artwork file is no longer available on this device.');
    }
    if ((expected.lid && !art.lidArtworkUrl) || (expected.lidOriginal && !art.lidArtworkOriginalUrl)) {
      throw new Error('The lid artwork is no longer available on this device.');
    }
    if (((expected.ring || (config.lidWrap && config.kind !== 'jar-labels')) && !art.ringArtworkUrl) || (expected.ringOriginal && !art.ringArtworkOriginalUrl)) {
      throw new Error('The full lid wrap artwork or its original file is no longer available on this device.');
    }
    // Keep pre-ring checkout fingerprints identical for unchanged legacy carts.
    if (!art.ringArtworkUrl && !art.ringArtworkOriginalUrl) {
      delete art.ringArtworkUrl;
      delete art.ringArtworkOriginalUrl;
    }
    return art;
  }
  return new Promise(function(resolve, reject) {
    var timer = setTimeout(function() { reject(new Error('Artwork storage did not respond. Please try again.')); }, 10000);
    Promise.resolve().then(function() { return ArtworkStore.get(item.id); }).then(merge, function() {
      // Blocked IndexedDB is safe only while all required originals remain in memory.
      return merge(null);
    }).then(function(art) { clearTimeout(timer); resolve(art); }, function(err) { clearTimeout(timer); reject(err); });
  });
}

function cartStorageItems(items) {
  // Full artwork stays in IndexedDB; this metadata also identifies a saved checkout.
  return items.map(function(it) {
    return {
      id:          it.id,
      name:        it.name,
      qty:         it.qty,
      unitPrice:   it.unitPrice,
      total:       it.total,
      properties:  it.properties,
      cat:         it.cat || (it.configuration && it.configuration.cat) || (cartItemIsJarCase(it) ? 'jars' : undefined),
      configuration: it.configuration || null,
      artworkFile:  it.artworkFile,
      artworkThumb: it.artworkThumb || '', // small JPEG thumbnail (~100px) — safe for sessionStorage
      thumbUrl:     it.thumbUrl || '',   // small product image path, not a data URL
      liveStoreUrl: it.liveStoreUrl || undefined
    };
  });
}

function saveCart() {
  try {
    sessionStorage.setItem('vp_order_ref', currentOrderRef || '');
    sessionStorage.setItem('vp_cart', JSON.stringify(cartStorageItems(cartItems)));
    invalidateSavedCheckout();
    return true;
  } catch(e) { return false; }
}

function updateCartBadge() {
  // #cartBadge lives inside nav.html, which loads asynchronously via
  // VP.inject -- it may not exist yet the first time this runs during
  // page init. Bail quietly; the .then() on the nav injection call
  // re-invokes this once nav.html is actually in the DOM.
  var badge = document.getElementById('cartBadge');
  if (!badge) return;
  badge.textContent = cartItems.length;
  badge.style.display = cartItems.length > 0 ? 'inline-flex' : 'none';
  badge.classList.toggle('visible', cartItems.length > 0);
}

function openCartDrawer() {
  renderCartDrawer();
  // A toast left from the builder would sit over Continue to payment.
  var notif = document.getElementById('cartNotif');
  if (notif) { notif.classList.remove('show'); clearTimeout(cartEditNotice.timer); }
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer(e) {
  if (e && e.target !== document.getElementById('cartOverlay')) return;
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function applyCartConfiguration(config, item, art) {
  if (!CATEGORIES[config.cat]) throw new Error('This product is no longer available in the builder.');
  var chip = cartProductCatalog().find(function(c) {
    return c.cat === config.cat && (config.chipId ? c.id === config.chipId : c.name === config.productName);
  });
  if (config.chipId && !chip) throw new Error('This product option is no longer available.');
  var matIdx = MATERIALS.findIndex(function(m) { return m.id === config.materialId; });
  var isPrint = config.cat === 'posters' || (chip && (chip.id === 'posters' || chip.id === 'yard-signs' || chip.id === 'banners'));
  if (matIdx < 0) {
    if (!isPrint) throw new Error('This material is no longer available.');
    matIdx = 0;
  }
  if (!(Number(config.qty) > 0)) throw new Error('The saved quantity is invalid.');

  resetArtwork();
  if (chip) switchProductChip(chip);
  else {
    var cat = CATEGORIES[config.cat];
    delete cat._customName;
    delete cat._customImage;
    if (config.productName && config.productName !== cat.name) cat._customName = config.productName;
    currentChipId = null;
    window._navHighlight = config.nav || config.cat;
    switchCategory(config.cat);
  }

  if (getPackagingProduct()) {
    var pkgSelect = document.getElementById('packageSizeSelect');
    var savedPkg = config.packageSize;
    var pkg = savedPkg && (getPackagingProduct().sizes || []).find(function(sz) {
      return savedPkg.id ? sz.id === savedPkg.id : sz.label === savedPkg.label;
    });
    if (savedPkg && !pkg) throw new Error('This package size is no longer available.');
    if (pkg && savedPkg.sideW !== undefined && ['sideW', 'sideH', 'topW', 'topH'].some(function(key) {
      return Number(pkg[key] || 0) !== Number(savedPkg[key] || 0);
    })) throw new Error('This package size has changed. The original cart item was kept.');
    pkgSelect.value = pkg ? pkg.id : '';
    onPackageSizeChange();
    buildQtySelect();
  } else {
    buildSizeSelect();
    buildQtySelect();
    var radios = Array.from(document.querySelectorAll('input[name="sqSize"]'));
    var selected = radios.find(function(r) { return r.value === config.sizeLabel; });
    if (!selected && config.width > 0 && config.height > 0) {
      selected = radios.find(function(r) { return r.value === 'Custom'; });
    }
    if (!selected) throw new Error('This size could not be restored.');
    var w = document.getElementById('customW');
    var h = document.getElementById('customH');
    w.value = config.sizeLabel === 'Custom' ? (config.customW || config.width || '') : (selected.value === 'Custom' ? config.width : config.customW || '');
    h.value = config.sizeLabel === 'Custom' ? (config.customH || config.height || '') : (selected.value === 'Custom' ? config.height : config.customH || '');
    if (selected.value === 'Custom' && !(Number(w.value) > 0 && Number(h.value) > 0)) throw new Error('The saved dimensions are invalid.');
    radios.forEach(function(r) { r.checked = r === selected; });
    onSizeChange(true);
  }

  setQty(config.qty);
  selectMaterial(matIdx);
  if (config.underlay) currentUnderlay = config.underlay;
  // setFinish clears specialty, so restore the separate specialty state last.
  setFinish(config.finish || 'glossy');
  setSpecialtyFinish(SPECIALTY_LABELS[config.specialty] ? config.specialty : 'none');
  setEmboss(config.emboss || 'none');
  if (config.printFinish) currentPrintFinish = config.printFinish;
  if (config.printSides) currentPrintSides = config.printSides;
  if (typeof updatePrintOptionButtons === 'function') updatePrintOptionButtons();
  if (typeof applyPrintPreviewFinish === 'function') applyPrintPreviewFinish();
  if (config.jarColor) {
    currentJarColor = config.jarColor;
    if (config.productName === 'Flower Jar Labels') selectJarColor(config.jarColor);
  }
  var notes = document.getElementById('specialInstr');
  if (notes) notes.value = config.notes || '';
  if (typeof setEdgeCut === 'function') setEdgeCut(!!config.edgeCut);

  artworkDataUrl = art.artworkUrl || null;
  artworkOriginalDataUrl = art.artworkOriginalUrl || null;
  lidArtworkDataUrl = art.lidArtworkUrl || null;
  lidArtworkOriginalDataUrl = art.lidArtworkOriginalUrl || null;
  artworkFile = item.artworkFile || '(none)';
  function upload(previewId, label, data, filename) {
    var prev = document.getElementById(previewId);
    if (prev) { prev.src = data || ''; prev.style.display = data ? 'block' : 'none'; }
    if (label && data) label.innerHTML = '✓ <strong>' + escHtml(filename || 'Artwork loaded') + '</strong>';
  }
  upload('uploadPreview', document.querySelector('.upload-label'), artworkDataUrl, config.bodyFilename || artworkFile);
  upload('uploadPreviewLid', document.getElementById('lidUploadLabel'), lidArtworkDataUrl, config.lidFilename || 'Lid artwork');
  setPreviewHint(!artworkDataUrl);
  var dlBtn = document.getElementById('printDlBtn');
  if (dlBtn) dlBtn.classList.toggle('visible', !!artworkDataUrl);
  if (currentCat === 'labels' && isSheetLabelProduct()) renderSheetLabelPreview();
  else if ((currentCat === 'labels' || currentCat === 'packaging') && typeof preview3D !== 'undefined') preview3D.activate(artworkDataUrl);
  else showArtworkPreview();
  if (config.uploadTab) setUploadTab(config.uploadTab);
  updatePrice();
  updateCartButtonState();
  if (typeof saveProductState === 'function') saveProductState();
}

// Reorder (Josh 10/25): what must stay equal through an edit for the line to still be the past order's design — the
// printed spec only, normalized (a replayed configuration and a captured one spell numbers, defaults and absent keys
// differently; GPT Sol 10/25 r5). Quantity and notes may change; the artwork is compared separately (cartArtSig).
function cartReorderSpec(c) {
  c = c || {};
  var num = function (v) { var n = Number(v); return isFinite(n) && v !== '' && v != null ? n : null; };
  var str = function (v) { return v == null ? '' : String(v).trim(); };
  var pkg = c.packageSize && typeof c.packageSize === 'object' ? (c.packageSize.id || c.packageSize.label || '') : '';
  return JSON.stringify([str(c.cat), str(c.chipId), str(c.productName), str(c.sizeLabel), num(c.width), num(c.height),
    str(c.sizeLabel) === 'Custom' ? num(c.customW) : null, str(c.sizeLabel) === 'Custom' ? num(c.customH) : null,
    str(c.materialId), str(c.finish || 'glossy'), str(c.specialty || 'none'), str(c.emboss || 'none'), str(pkg),
    !!c.edgeCut, str(c.productName) === 'Flower Jar Labels' ? str(c.jarColor || 'black') : '']);
  // (poster finish / sides ride the line's properties, and captureCartConfiguration() carries no printFinish: left out)
}
// The artwork itself (the data URLs, compared byte for byte — two different files can be the same length), plus the
// print products' Finish / Sides, which live on the line's properties rather than in the configuration.
function cartArtSig() {
  return [artworkDataUrl || '', artworkOriginalDataUrl || '', lidArtworkDataUrl || '', lidArtworkOriginalDataUrl || ''];
}
function cartArtSame(a, b) {
  if (!a || !b || a.length !== b.length) return false;
  for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
  return true;
}
function cartPrintProps(properties) {
  var out = {};
  (properties || []).forEach(function (p) { if (p && (p.name === 'Finish' || p.name === 'Sides')) out[p.name] = String(p.value || ''); });
  return JSON.stringify(out);
}

function editCartItem(id) {
  if (_cartCheckingOut || _cartSaving) return Promise.resolve(false);
  var item = cartItems.find(function(it) { return it.id === id; });
  if (!item) return Promise.resolve(false);
  cancelCartEdit(true);

  // Native editors keep the original line until their replacement is durable.
  if (cartItemIsJarCase(item) || cartItemIsNativeJarLabels(item)) {
    window.location.href = (cartItemIsNativeJarLabels(item) ? "/?view=jar-labels" : "/?view=jars") + '&edit=' + encodeURIComponent(item.id);
    return Promise.resolve(false);
  }

  var editing = { item: item, phase: 'loading' };
  _cartEditing = editing;
  cartEditNotice('Loading your saved artwork and settings…');
  return Promise.resolve().then(function() {
    updateCartBusyState();
    var config = cartItemConfiguration(item);
    return restoreCartArtwork(item, config).then(function(art) {
      if (_cartCheckingOut || _cartEditing !== editing || cartItems.indexOf(item) < 0) {
        if (_cartEditing === editing) cancelCartEdit(true);
        return false;
      }
      applyCartConfiguration(config, item, art);
      editing.artSig = cartArtSig();   // the restored artwork, to tell a re-upload from a same-design edit
      editing.cat = currentCat;
      editing.chipId = currentChipId;
      editing.productName = CATEGORIES[currentCat]._customName || CATEGORIES[currentCat].name;
      editing.phase = 'ready';
      updateCartBusyState();
      closeCartDrawer(null);

      var btn = document.querySelector('.btn-atc');
      if (btn) {
        btn.dataset.cartAddLabel = btn.textContent;
        btn.textContent = 'Update Cart';
        var banner = document.createElement('div');
        banner.id = 'cartEditNotice';
        banner.className = 'proof-note';
        banner.setAttribute('role', 'status');
        banner.textContent = 'Editing ' + item.name + '. The original stays in your cart until Update Cart. ';
        var cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.textContent = 'Cancel edit';
        cancel.onclick = function() { cancelCartEdit(); };
        banner.appendChild(cancel);
        btn.parentNode.insertBefore(banner, btn);
      }
      cartEditNotice('Editing — click Update Cart to save, or Cancel edit to keep the original.');
      var cfg = document.getElementById('configurator') || document.querySelector('.configurator-wrap');
      if (cfg) cfg.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    });
  }).catch(function(err) {
    if (_cartEditing === editing) {
      cancelCartEdit(true);
      cartEditNotice('Could not edit: ' + err.message + ' Your cart item is unchanged.');
    }
    console.warn('[Cart] restore failed:', err);
    return false;
  });
}


function removeCartItem(id) {
  if (_cartCheckingOut) return false;
  if (_cartEditing && _cartEditing.item.id === id) cancelCartEdit();
  cartItems = cartItems.filter(function(it) { return it.id !== id; });
  cartCount = cartItems.length;
  saveCart();
  updateCartBadge();
  renderCartDrawer();
}

function clearCart() {
  if (_cartCheckingOut) return false;
  if (_cartEditing) cancelCartEdit(true);
  cartItems = [];
  cartCount = 0;
  currentOrderRef = null;  // next cart session gets a fresh order ref
  saveCart();
  updateCartBadge();
  renderCartDrawer();
  // Other tabs and pending checkouts can still own the stored originals.
}


function toggleCartJson() {
  var body   = document.getElementById('cartJsonBody');
  var toggle = document.getElementById('cartJsonToggle');
  var open   = body.classList.toggle('open');
  toggle.classList.toggle('expanded', open);
}

function renderCartDrawer() {
  var container = document.getElementById('cartItemsContainer');
  var empty     = document.getElementById('cartEmpty');
  var footer    = document.getElementById('cartDrawerFooter');
  var jsonSec   = document.getElementById('cartDrawerJson');
  var label     = document.getElementById('cartCountLabel');

  label.textContent = cartItems.length === 1 ? '1 item' : cartItems.length + ' items';
  refreshCartCheckoutUI();

  if (cartItems.length === 0) {
    empty.style.display   = '';
    container.innerHTML   = '';
    footer.style.display  = 'none';
    jsonSec.style.display = 'none';
    return;
  }

  empty.style.display   = 'none';
  footer.style.display  = '';
  jsonSec.style.display = '';

  // Build all item card HTML in one pass, set via innerHTML
  var grandTotal = 0;
  var html = '';
  cartItems.forEach(function(item) {
    grandTotal += parseFloat(item.total) || 0;

    var propMap = {};
    cartNativeProperties(item).forEach(function(p) { propMap[p.name] = p.value; });
    var config = item.configuration || {};
    var artworkLabel = cartItemIsNativeJarLabels(item) ? [
      config.bodyFilename ? 'Body: ' + config.bodyFilename : '',
      config.lidFilename ? 'Lid: ' + config.lidFilename : '',
      config.ringFilename ? 'Ring: ' + config.ringFilename : ''
    ].filter(Boolean).join(' · ') : (config.bodyFilename || item.artworkFile);   // the customer's own file name (Josh 10/17)
    if ((!artworkLabel || artworkLabel === '(none)') && !cartItemIsJarCase(item)) artworkLabel = 'Send after checkout';
    // Holo, glitter, chrome, gold and reflective vinyl use their own name as the finish too, so the line read
    // "Holo · 2" × 2" · Holo" and never named the laminate (Josh 10/18). There it names the laminate instead.
    var finishWord = propMap['Finish'] && String(propMap['Finish']).toLowerCase() === String(propMap['Material'] || '').toLowerCase()
      ? (propMap['Laminate'] === 'Gloss' || propMap['Laminate'] === 'Matte' ? propMap['Laminate'] + ' laminate' : null)
      : propMap['Finish'];
    var propLine = [
      propMap['Material'], propMap['Size'], cartItemIsNativeJarLabels(item) ? null : propMap['Tier'], finishWord,
      cartItemIsNativeJarLabels(item) ? propMap['White Ink'] : null,
      cartItemIsNativeJarLabels(item) && config.lidWrap ? 'Lid wrap included' : null,
      cartItemIsNativeJarLabels(item) && config.addJars ? propMap['Glass Jars'] : null,
      cartItemIsNativeJarLabels(item) && config.application ? propMap['Application'] : null,
      cartItemIsNativeJarLabels(item) ? jarLabelEmbossSummary(config.tier, config.emboss) :
        propMap['Emboss'] && propMap['Emboss'] !== 'Flat' ? 'emboss ' + (/^light$/i.test(propMap['Emboss']) ? 'Standard' : propMap['Emboss']) : null,
      propMap['Specialty Finish'] !== 'None' ? propMap['Specialty Finish'] : null,
      propMap['Cut'] ? 'cut to artwork edge' : null
    ].filter(Boolean).join(' · ');

    html +=
      '<div class="cart-item-card">' +
        '<div class="cart-item-top">' +
          '<img class="cart-item-thumb" src="' + (item.previewUrl || item.thumbUrl || '') + '" alt="' + escHtml(item.name) + ' preview">' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + escHtml(item.name) + '</div>' +
            '<div class="cart-item-props">' +
              '<span>' + escHtml(propLine) + '</span>' +
              '<span>Qty: ' + item.qty + '</span>' +
            '</div>' +
            '<div class="cart-item-price">$' + item.total +
              ' <span class="cart-item-unit">($' + (cartItemIsNativeJarLabels(item) ? Number(item.unitPrice).toFixed(2) : item.unitPrice) + '/unit)</span>' +
            '</div>' +
            '<span class="cart-item-actions">' +
              '<button type="button" class="cart-item-edit" data-cart-focus="edit-' + item.id + '" aria-label="Edit ' + escHtml(item.name) + '" onclick="editCartItem(' + item.id + ')">Edit</button>' +
              '<button type="button" class="cart-item-remove" data-cart-focus="remove-' + item.id + '" aria-label="Remove ' + escHtml(item.name) + ' from cart" onclick="removeCartItem(' + item.id + ')">Remove</button>' +
            '</span>' +
          '</div>' +
        '</div>' +
        (artworkLabel && artworkLabel !== '(none)' ?
          '<div class="cart-item-artwork">' +
            (item.artworkThumb ? '<img src="' + item.artworkThumb + '" alt="" style="max-height:60px;width:auto;border-radius:4px;margin-right:8px">' : '') +
            '<span>Artwork: ' + escHtml(artworkLabel) + '</span>' +
          '</div>' : '') +
      '</div>';
  });

  container.innerHTML = html;

  // Total
  document.getElementById('cartTotalAmt').textContent = '$' + grandTotal.toFixed(2);

  // Build combined Draft Order JSON — use the same function checkoutSim() uses
  var draftOrder = buildCheckoutPayload(null);
  var jsonStr = JSON.stringify(draftOrder, null, 2);
  document.getElementById('cartJsonPre').innerHTML = syntaxHighlight(jsonStr);
  document.getElementById('cartJsonPre').dataset.raw = jsonStr;
}

function cartNativeProperties(item) {
  var props = (item.properties || []).slice();
  var config = item.configuration;
  if (!config || (config.kind !== 'jars' && config.kind !== 'jar-labels')) return props;
  function set(name, value) {
    if (value === undefined || value === null || value === '') return;
    props = props.filter(function(p) { return p.name !== name; });
    props.push({ name: name, value: String(value) });
  }
  set('Source Product ID', config.productId);
  set('Source Variant ID', config.variantId);
  set('Tier', config.tier);
  set('Finish', config.finish);
  set('Emboss', config.emboss);
  set('White Ink', config.whiteInk);
  set('Jar Type', config.jarType);
  set('Jar Type Details', config.jarTypeDetails);
  set('Special Notes', config.notes);
  set('Body Artwork File', config.bodyFilename);
  set('Lid Artwork File', config.lidFilename);
  set('Lid Wrap Artwork File', config.ringFilename);
  if (config.kind === 'jar-labels') {
    set('Quantity Unit', 'Top + wrap sets');
    set('Lid Wrap', config.lidWrap ? 'Included in this line price; one per set' : 'None');
    if (config.lidWrap) {
      set('Lid Wrap Source Variant ID', config.lidWrap.variantId);
      set('Lid Wrap Price Cents', config.lidWrap.priceCents);
    }
  }
  return props;
}

// ─── CHECKOUT PAYLOAD BUILDER — single source of truth ───────────────────────
// Called by renderCartDrawer() (folderUrl = null → placeholder) and
// checkoutSim() (folderUrl = real Drive URL after upload).
function buildCheckoutPayload(folderUrl) {
  if (!cartItems.length) return null;
  var orderRef    = currentOrderRef || 'ORD-0000';
  var totalQty    = cartItems.reduce(function(sum, it) { return sum + (parseInt(it.qty) || 0); }, 0);
  var designCount = cartItems.length;

  // ── Line Item Summary — pipe-delimited, one design per line ─────────────
  // Format: Design N: Product Type | Material | Size | Finish | Emboss | Specialty Finish | Qty units | Special Notes
  var lineItemSummary = cartItems.map(function(item, i) {
    function prop(name) {
      var p = (item.properties || []).find(function(p) { return p.name === name; });
      return (p && p.value) ? String(p.value).trim() : '';
    }
    var productType     = prop('Product Type')     || item.name || '';
    var material        = prop('Material')         || '';
    var size            = prop('Size')             || '';
    var finish          = prop('Finish')           || '';
    var emboss          = prop('Emboss')           || '';
    if (/^light$/i.test(emboss)) emboss = 'Standard';
    var specialtyFinish = prop('Specialty Finish') || '';
    var specialNotes    = prop('Special Notes')    || '';

    var parts = [productType, material, size, finish];
    if (emboss && emboss !== 'Flat') parts.push('emboss ' + emboss);
    parts.push(specialtyFinish, item.qty + (cartItemIsNativeJarLabels(item) ? ' jars' : ' units'));
    if (cartItemIsNativeJarLabels(item) && item.configuration.addJars) {
      parts.push(prop('Glass Jars'), prop('Application'));
      if (prop('Spare Jars')) parts.push('Spare jars: ' + prop('Spare Jars'));
    }
    // Only include Special Notes if it has a real value (not empty or em-dash placeholder)
    if (specialNotes && specialNotes !== '—' && specialNotes !== '-') {
      parts.push(specialNotes);
    }
    return 'Design ' + (i + 1) + ': ' + parts.join(' | ');
  }).join('\n');

  var noteAttrs = [
    { name: 'Order Ref',          value: orderRef },
    { name: 'Design Count',       value: String(designCount) },
    { name: 'Total Quantity',     value: String(totalQty) },
    { name: 'Artwork (Drive)',    value: folderUrl || '(uploaded at checkout)' },
    { name: 'Line Item Summary',  value: lineItemSummary }
  ];

  var allLineItems = cartItems.map(function(item) {
    return {
      title:             item.name,
      price:             item.unitPrice,
      quantity:          item.qty,
      requires_shipping: true,
      properties:        cartNativeProperties(item)
    };
  });

  return {
    draft_order: {
      line_items:      allLineItems,
      note:            'VINYLPAC custom order — ' + designCount + ' design(s), ' + totalQty + ' units total. Artwork folder in Google Drive.',
      note_attributes: noteAttrs,
      tags:            'custom-print, vinylpac-configurator',
      send_receipt:    false
    }
  };
}

// ─── CHECKOUT HANDOFF ────────────────────────────────────────────────────────

var _savedCheckoutMemory = null;
var CHECKOUT_STORAGE_KEY = 'vp_checkout_pending';

function isLocalCheckoutPreview() {
  if (window.VP_CHECKOUT_ALLOW_LOCAL === true && window.VP_API_BASE) return false; // [vp-theme-checkout patch v1]
  return /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);
}

function checkoutCanonical(value) {
  if (Array.isArray(value)) return value.map(checkoutCanonical);
  if (value && typeof value === 'object') {
    var sorted = {};
    Object.keys(value).sort().forEach(function(key) { sorted[key] = checkoutCanonical(value[key]); });
    return sorted;
  }
  return value;
}

function checkoutCartIdentity() { // [vp-theme-checkout patch v1]
  // One buyer per checkout: another sign-in on this tab gets its own key and draft. Guests: unchanged.
  var cart = JSON.stringify(checkoutCanonical(cartStorageItems(cartItems)));
  var b = typeof window !== 'undefined' ? window.VP_BUYER : null;
  var id = b && typeof b === 'object' && b.id ? cart + '|buyer:' + String(b.id) : cart;
  var w = vpWelcomeBody();
  if (w) id += '|welcome:' + w.code;   // adding or removing the code is another checkout (guests without one: unchanged)
  var o = vpBulkOrderBody();
  if (o) id += '|order:' + JSON.stringify(checkoutCanonical(o));   // Bulk Order Form answers (rush changes the total)
  else if (vpMockupsApplies() && !vpMockupsWanted()) id += '|mockups:no';   // ticked (the default): the old identity
  return vpTeamTestKey() ? id + '|teamtest' : id;   // a team test checkout never resumes a real one, or the reverse
}

function readSavedCheckout() {
  if (_savedCheckoutMemory) return _savedCheckoutMemory;
  var raw = sessionStorage.getItem(CHECKOUT_STORAGE_KEY);
  if (!raw) return null;
  var saved;
  try { saved = JSON.parse(raw); } catch(e) {}
  if (!saved || saved.version !== 1 || !/^[a-f0-9]{64}$/.test(saved.key) ||
      typeof saved.cart !== 'string' || !/^(creating|ready)$/.test(saved.status)) {
    throw new Error('The saved checkout could not be read. Contact the shop before trying another order.');
  }
  return saved;
}

function writeSavedCheckout(saved) {
  // Keep a known link in this document even if a later storage write fails.
  _savedCheckoutMemory = saved;
  var raw = JSON.stringify(saved);
  sessionStorage.setItem(CHECKOUT_STORAGE_KEY, raw);
  if (sessionStorage.getItem(CHECKOUT_STORAGE_KEY) !== raw) throw new Error('Checkout storage is unavailable.');
}

function forgetSavedCheckout() {
  sessionStorage.removeItem(CHECKOUT_STORAGE_KEY);
  _savedCheckoutMemory = null;
}

function invalidateSavedCheckout() {
  try {
    var saved = readSavedCheckout();
    // An uncertain draft must be reconciled, even if the customer edits the cart.
    if (saved && saved.status === 'ready' && saved.cart !== checkoutCartIdentity()) {
      forgetSavedCheckout();
      var status = document.getElementById('cartCheckoutStatus');
      if (status) { status.textContent = ''; status.hidden = true; }
    }
  } catch(e) { /* Checkout itself blocks when its saved state cannot be read. */ }
}

function cartCheckoutStatus(message, error) { // [vp-theme-checkout patch v1]
  // Josh 10/12: a message sits with the button, in the cart's footer, so the cart above it never moves
  // (it used to be put above the first item and pushed the whole cart down).
  var footer = document.getElementById('cartDrawerFooter');
  var body = document.getElementById('cartDrawerBody');
  if (!footer && !body) return;
  var status = document.getElementById('cartCheckoutStatus');
  if (!status) {
    status = document.createElement('p');
    status.id = 'cartCheckoutStatus';
    status.tabIndex = -1;
    status.style.cssText = 'margin:0;padding:12px;border:1px solid #777;border-radius:4px;font-size:14px;line-height:1.5;overflow-wrap:anywhere';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    if (footer) {
      var help = document.getElementById('cartCheckoutHelp');
      var button = document.querySelector('.cart-btn-checkout');
      var before = help && help.parentNode === footer ? help : button && button.parentNode === footer ? button : null;
      footer.insertBefore(status, before);
    } else {
      body.insertBefore(status, body.firstChild);
    }
  }
  status.setAttribute('role', error ? 'alert' : 'status');
  status.textContent = message;
  status.hidden = !message;
  if (error) {
    var contact = document.createElement('a');
    var email = window.VP_SITE && window.VP_SITE.emailHref || 'mailto:info@vinylpac.us';
    contact.href = email + (email.indexOf('?') === -1 ? '?' : '&') + 'subject=' + encodeURIComponent('Checkout help ' + (currentOrderRef || ''));
    contact.textContent = 'Contact the shop';
    contact.style.cssText = 'display:block;margin-top:8px;color:inherit;text-decoration:underline';
    status.appendChild(contact);
    status.focus();
    status.scrollIntoView({ block: 'nearest' });
  }
}

function nativeJarLabelCheckoutMessage() {
  return 'Jar-label payment is not available here yet: Shopify variant and volume-discount validation is not connected. No order was sent. Your local cart and full artwork stay saved. Use the selected live-store product link below; its cart and uploads are separate.';
}

function nativeJarLabelStoreUrl(item) {
  var config = item.configuration || {};
  if (config.addJars || config.application || config.whiteInk === 'No white') return null;
  var paths = {
    'miron-5ml-ceres': 'miron-5ml-jar-labels-top-sticker-perforated-wrap',
    'miron-5ml-eris': 'miron-5ml-jar-labels-top-sticker-perforated-wrap',
    'black-4oz': '4oz-1-8-oz-jar-labels-top-sticker-jar-wrap',
    'miron-150ml': 'miron-150ml-jar-labels-top-sticker-jar-wrap'
  };
  var candidate = item.liveStoreUrl || config.liveStoreUrl;
  if (!candidate && paths[config.productId]) candidate = 'https://vinylpac.us/products/' + paths[config.productId];
  try {
    var url = new URL(candidate);
    if (url.protocol !== 'https:' || !/^(www\.)?vinylpac\.us$/.test(url.hostname) || !url.pathname.startsWith('/products/') || url.username || url.password || url.port) return null;
    if (!/^\d+$/.test(String(config.variantId || ''))) return null;
    url.searchParams.set('variant', config.variantId);
    return url.href;
  } catch (e) { return null; }
}

function appendNativeJarLabelLinks(container) {
  cartItems.filter(cartItemIsNativeJarLabels).forEach(function(item) {
    var link = document.createElement('a');
    var live = nativeJarLabelStoreUrl(item);
    link.href = live || "/?view=jar-labels&edit=" + encodeURIComponent(item.id);
    link.textContent = live ? 'Open ' + item.name + ' — selected live-store options' : 'Review ' + item.name + ' and its live-store link';
    if (live) { link.target = '_blank'; link.rel = 'noopener'; }
    link.style.cssText = 'display:block;margin-top:8px;color:inherit;text-decoration:underline';
    container.appendChild(link);
  });
}

function uncertainCheckoutMessage(saved) {
  return 'Your checkout is still being confirmed (reference ' + (saved.orderRef || 'unavailable') + '). Nothing has been charged. ' +
    'Wait a minute, then tap the button again; it picks up this same checkout.'; // [vp-theme-checkout patch v1]
}

function refreshCartCheckoutUI() { // [vp-theme-checkout patch v1]
  var footer = document.getElementById('cartDrawerFooter');
  var button = document.querySelector('.cart-btn-checkout');
  if (!footer || !button) return;
  var help = document.getElementById('cartCheckoutHelp');
  if (!help) {
    help = document.createElement('p');
    help.id = 'cartCheckoutHelp';
    help.style.cssText = 'margin:0;font-size:13px;line-height:1.5;color:#444';
    footer.insertBefore(help, button);
  }
  button.setAttribute('aria-describedby', 'cartCheckoutHelp');
  // Josh 10/12: while checking out, and while the browser leaves for Shopify, the button and its help line
  // stay exactly as they are (no flip to "Resume payment" before Shopify's page shows).
  if (_cartCheckingOut) { updateCartBusyState(); return; }
  vpWaitStop();
  button.classList.remove('vp-going');
  var saved = null;
  var savedError = null;
  invalidateSavedCheckout();
  try { saved = readSavedCheckout(); } catch(e) { savedError = e; }
  // The help line says how shipping works for this cart (Josh 10/11, vpShipText / vpShipRefresh); after
  // Back from Shopify it says the checkout is saved instead (no extra message box).
  help.textContent = isLocalCheckoutPreview()
    ? 'Checkout is unavailable in this local preview. No order will be sent.'
    : saved && saved.status === 'ready'
      ? VP_CHECKOUT_TEXT.saved
      : 'Next: Shopify to review delivery details and pay. ' + vpShipText() + ' Your cart stays saved; returning here does not confirm payment.';
  if (vpTeamTestKey() && !isLocalCheckoutPreview()) help.textContent = 'Team test: Shopify will show $0 to pay. Nothing is charged.';
  vpShipRefresh();
  try { vpBulkRender(footer); } catch (e) { if (window.console && console.warn) console.warn('[bulk]', e); }   // Bulk Order Form: rush + mockups
  try { vpDealRender(footer); } catch (e) { if (window.console && console.warn) console.warn('[deal]', e); }   // Josh 10/31: monthly deals
  try { vpWelcomeRender(footer); } catch (e) { if (window.console && console.warn) console.warn('[welcome]', e); }   // never in the way of checkout
  try { vpMockupsRender(footer, help); } catch (e) { if (window.console && console.warn) console.warn('[mockups]', e); }   // Josh 10/18: mockups yes/no
  if (cartHasNativeJarLabels()) {
    help.textContent = (isLocalCheckoutPreview() ? 'Local preview: no order will be sent. ' : '') + nativeJarLabelCheckoutMessage();
    appendNativeJarLabelLinks(help);
  }
  if (isLocalCheckoutPreview() || cartHasNativeJarLabels()) {
    button.textContent = 'Checkout unavailable';
  } else if (savedError) {
    button.textContent = 'Continue to payment';
    cartCheckoutStatus(savedError.message, false);
  } else {
    button.textContent = saved && saved.status === 'ready' ? 'Resume payment' : 'Continue to payment';
    var status = document.getElementById('cartCheckoutStatus');
    if ((!status || !status.textContent) && saved && saved.status === 'creating') cartCheckoutStatus(uncertainCheckoutMessage(saved), false);
  }
  // Josh 10/19: the cart's draft is made in the background while the buyer looks at it (vpWarmSoon).
  try { vpWarmSoon(); } catch (e) {}
  updateCartBusyState();
}

function checkoutJsonRequest(url, options, label) {
  return new Promise(function(resolve, reject) {
    var controller = new AbortController();
    var timer = setTimeout(function() {
      controller.abort();
      reject(new Error(label + ' timed out.'));
    }, 30000);
    var request = Object.assign({}, options, { signal: controller.signal });
    Promise.resolve().then(function() { return fetch(url, request); }).then(function(response) {
      if (!response.ok) {
        var error = new Error(label + ' is unavailable (HTTP ' + response.status + ').');
        error.httpStatus = response.status;
        throw error;
      }
      return response.json().catch(function() { throw new Error(label + ' returned an unreadable response.'); });
    }).then(function(data) {
      clearTimeout(timer);
      if (!data || typeof data !== 'object') reject(new Error(label + ' returned an incomplete response.'));
      else resolve(data);
    }, function(error) {
      clearTimeout(timer);
      reject(error);
    });
  });
}

function dataUrlToBlob(dataUrl) {
  var match = /^data:([^;,]+);base64,([a-z0-9+/\s]*={0,2})$/i.exec(dataUrl || '');
  if (!match || !/^[a-z0-9][a-z0-9!#$&^_.+-]*\/[a-z0-9][a-z0-9!#$&^_.+-]*$/i.test(match[1])) throw new Error('The full artwork file is invalid.');
  var binary = atob(match[2]);
  if (!binary.length) throw new Error('The full artwork file is empty.');
  var arr = new Uint8Array(binary.length);
  for (var i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
  return new Blob([arr], { type: match[1] });
}

function driveUploadUri(uri) {
  var url = new URL(uri);
  if (url.protocol !== 'https:' || !/^(www|content)\.googleapis\.com$/.test(url.hostname) ||
      !url.pathname.startsWith('/upload/drive/') || url.username || url.password || url.port) {
    throw new Error('The artwork upload address is invalid.');
  }
  return url.href;
}

function checkoutPaymentUrl(uri) {
  var url = new URL(uri);
  if (url.protocol !== 'https:' || url.username || url.password || url.port ||
      !/(^|\.)myshopify\.com$/.test(url.hostname) &&
      !/^(checkout\.shopify\.com|vinylpac\.us|www\.vinylpac\.us)$/.test(url.hostname)) {
    throw new Error('The payment link is invalid. Contact the shop before trying another order.');
  }
  return url.href;
}

// Every resumable upload must finish with a confirmed Drive file ID.
function uploadToSessionUri(sessionUri, blob) {
  return Promise.resolve().then(function() {
    return checkoutJsonRequest(driveUploadUri(sessionUri), {
      method: 'PUT', headers: { 'Content-Type': blob.type }, body: blob
    }, 'Artwork upload');
  }).then(function(data) {
    if (typeof data.id !== 'string' || !/^[a-z0-9_-]+$/i.test(data.id)) throw new Error('Artwork upload was not confirmed.');
    return 'https://drive.google.com/file/d/' + data.id + '/view';
  });
}

// Josh 10/17: every file type is accepted. A name the browser can't show as it is (PDF, AI, PSD, EPS, TIFF, ZIP…)
// means the line carries the customer's original file beside its PNG preview.
function cartNeedsOriginal(name) {
  var ext = /\.([a-z0-9]{1,10})$/i.exec(String(name || '').trim());
  return !!ext && !/^(png|jpe?g|webp|gif|svg)$/i.test(ext[1]);
}

// The extension a file is uploaded under: its own type, else the customer's file name (PSD, AI, EPS…).
function cartUploadExt(blob, item, role) {
  var known = { 'application/pdf': 'pdf', 'image/png': 'png', 'image/jpeg': 'jpg', 'image/svg+xml': 'svg', 'image/webp': 'webp', 'image/gif': 'gif' }[blob.type];
  if (known) return known;
  var config = item && item.configuration || {};
  var ext = /\.([a-z0-9]{1,10})$/i.exec(String(config[role + 'Filename'] || (role === 'body' && item && item.artworkFile) || '').trim());
  if (ext) return ext[1].toLowerCase();
  return { 'image/vnd.adobe.photoshop': 'psd', 'application/postscript': 'ai', 'image/tiff': 'tif', 'image/heic': 'heic', 'application/zip': 'zip' }[blob.type] || 'bin';
}

function checkoutArtwork(item) {
  if (cartItemIsJarCase(item)) return Promise.resolve({});
  var config = Object.assign({}, item.configuration || {});
  // Josh 10/16: a line may have no artwork (it comes after checkout). Only what the item saved is required;
  // restoreCartArtwork still demands the full file whenever the item names one or carries a thumbnail.
  config.artwork = Object.assign({}, config.artwork || {});
  if (cartNeedsOriginal(config.bodyFilename) || cartNeedsOriginal(item.artworkFile)) config.artwork.bodyOriginal = true;
  if (cartNeedsOriginal(config.lidFilename)) {
    config.artwork.lid = true;
    config.artwork.lidOriginal = true;
  }
  if ((config.lidWrap && !cartItemIsNativeJarLabels(item)) || cartNeedsOriginal(config.ringFilename)) config.artwork.ring = true;
  if (cartNeedsOriginal(config.ringFilename)) config.artwork.ringOriginal = true;
  return restoreCartArtwork(item, config).then(function(art) {
    ['artworkUrl', 'artworkOriginalUrl', 'lidArtworkUrl', 'lidArtworkOriginalUrl', 'ringArtworkUrl', 'ringArtworkOriginalUrl'].forEach(function(field) {
      if (art[field]) dataUrlToBlob(art[field]);   // throws on an unreadable or empty file
    });
    return art;
  }).catch(function(error) {
    throw new Error(item.name + ': ' + error.message + ' Reattach the missing full file in the builder and replace this cart item; a thumbnail is not enough.');
  });
}

function checkoutFingerprint(identity, artwork, shipping) {
  if (!window.crypto || !window.crypto.subtle) return Promise.reject(new Error('Secure checkout requires HTTPS and browser storage.'));
  var full = JSON.stringify(checkoutCanonical({ cart: identity, artwork: artwork, shipping: shipping, orderRef: currentOrderRef }));
  return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(full)).then(function(hash) {
    return Array.from(new Uint8Array(hash)).map(function(byte) { return byte.toString(16).padStart(2, '0'); }).join('');
  });
}

// [vp-theme-checkout patch v1] — theme checkout API helpers (patch_cart_checkout.py).
// Server answers are authoritative: it re-prices every line, stores artwork in
// Shopify Files and creates the draft; the browser only goes to invoiceUrl.
//
// Josh 10/12, after a real test order on his iPhone (#4100): "I noticed that the checkout did a weird
// waiting step I'd like to streamline." From the tap until Shopify's page is on screen the cart shows ONE
// calm state: the button says "Taking you to checkout…" with a small spinner. No step names, no message box
// above the cart (the cart never moves), and no "Resume payment" while the browser is leaving. Errors, and
// a saved checkout after Back from Shopify, still say plainly what happened.
var VP_CHECKOUT_TEXT = {
  going: 'Taking you to checkout…',
  offline: "We couldn't reach checkout. Check your connection, then try again.",
  busy: 'Checkout is busy right now. Wait a minute, then try again.',
  paid: 'This order is already paid. Thank you! Your cart is empty now.',
  saved: 'Your checkout is saved. Resume payment picks up where you left off. Already paid? Check your email for the confirmation; no need to order again.',
  notSent: ' No order was sent.',
  unchanged: ' No order was sent; your cart is unchanged.',
  keepSaved: ' Your saved checkout is kept; do not start another order.',
  // Josh 10/29: a tap still waiting after VP_WAIT_WORDS_MS says on what (a usual tap has long left by then).
  uploading: 'Uploading your artwork…',
  preparing: 'Getting your checkout ready…'
};
var VP_WAIT_WORDS_MS = typeof window.VP_WAIT_WORDS_MS === 'number' ? window.VP_WAIT_WORDS_MS : 2000;
// The tap's wait, for the button: stage '' (Taking you to checkout…), 'upload' (with the share of bytes sent, once
// known, while any upload the tap waits on is still running: `uploads`) or 'draft'. Artwork all sent but still being
// taken in by Shopify, or every upload done while the price check is still out, reads as 'draft'.
var _vpWait = null;   // { button, at, stage, bytes: { name: [sent, total] }, uploads, poll, timer }
function vpWaitStart(button) {
  vpWaitStop();
  _vpWait = { button: button, at: Date.now(), stage: '', bytes: {}, uploads: 0, poll: null, timer: setTimeout(vpWaitPaint, VP_WAIT_WORDS_MS) };
}
// An upload the tap waits on: counted while it runs; its end repaints the button (Sol 10/29 r1: a stale "75%").
function vpWaitUpload(p) {
  var w = _vpWait;
  if (!w) return p;
  w.uploads++;
  var end = function() { w.uploads--; if (_vpWait === w) vpWaitPaint(); };
  return p.then(function(r) { end(); return r; }, function(e) { end(); throw e; });
}
function vpWaitStage(stage) {
  if (!_vpWait) return;
  _vpWait.stage = stage;
  vpWaitPaint();
}
function vpWaitBytes(name, sent, total) {
  if (!_vpWait) return;
  _vpWait.bytes[name] = [sent, total];
  vpWaitPaint();
}
function vpWaitPaint() {
  var w = _vpWait;
  if (!w || !w.button || Date.now() - w.at < VP_WAIT_WORDS_MS) return;
  var text = VP_CHECKOUT_TEXT.going;
  if (w.stage === 'upload') {
    var sent = 0, total = 0;
    Object.keys(w.bytes).forEach(function(k) { sent += w.bytes[k][0]; total += w.bytes[k][1]; });
    text = !w.uploads || (total > 0 && sent >= total) ? VP_CHECKOUT_TEXT.preparing
      : VP_CHECKOUT_TEXT.uploading + (total > 0 ? ' ' + Math.floor(100 * sent / total) + '%' : '');
  } else if (w.stage === 'draft') text = VP_CHECKOUT_TEXT.preparing;
  if (w.button.textContent !== text) w.button.textContent = text;
}
function vpWaitStop() {
  if (!_vpWait) return;
  clearTimeout(_vpWait.timer);
  clearTimeout(_vpWait.poll);
  _vpWait = null;
}
var VP_LEAVE_WATCHDOG_MS = 20000;   // still on this page this long after leaving for Shopify: give the cart back
var _vpLeaving = null;              // the payment link the browser is on its way to
// Josh 10/19, launch morning: Shopify often answers a draft's payment link with its own "There was a problem loading
// this website" page (status-code-500) when the link is opened in the first seconds after the draft is made: 11 of 27
// opens at 0.3-0.4 s and about 1 in 6 at 3 s failed, 0 of 61 at 6 s or later (DraftOrder.ready is true at once, so it
// can't tell). Cart checkouts never did it. So the browser holds "Taking you to checkout…" until the draft is this old
// before leaving (6 s was clean; 8 s keeps a margin). Josh 10/19: the theme setting vp_checkout_settle sets it (the page
// head's window.VP_DRAFT_SETTLE_MS; ?vpsettle=<seconds> per browser, vp-shim.js); the tests set the window value.
var VP_DRAFT_SETTLE_MS = (function() {
  try { var o = localStorage.getItem('vp_checkout_settle'); if (/^\d{1,2}$/.test(o || '')) return Number(o) * 1000; } catch (e) {}
  return typeof window.VP_DRAFT_SETTLE_MS === 'number' ? window.VP_DRAFT_SETTLE_MS : 8000;
})();

function vpCheckoutApi(path) {
  var base = String(window.VP_API_BASE || '').replace(/\/+$/, '');
  if (!/^https:\/\/[^/]+$|^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/.test(base)) {
    throw new Error('Checkout is not connected yet.');
  }
  return base + path;
}

function vpCheckoutError(message, label) {
  var error = new Error(message);
  error.vpLabel = label;   // for the console only; the customer reads the message
  return error;
}

// Like checkoutJsonRequest, but shows the server's own message and keeps httpStatus so the retry rules
// still apply. Sent as text/plain, a CORS "simple" request: no OPTIONS round trip before each call (measured
// 0.23-0.25 s per call on a phone link). The Worker reads the body as JSON whatever its type and still refuses
// any other site's Origin before doing anything. A dropped connection or a timeout reads as one plain sentence.
function vpCheckoutRequest(path, body, label, timeoutMs) {
  return new Promise(function(resolve, reject) {
    var controller = new AbortController();
    var timer = setTimeout(function() {
      controller.abort();
      reject(vpCheckoutError(VP_CHECKOUT_TEXT.offline, label + ' timed out'));
    }, timeoutMs || 30000);
    Promise.resolve().then(function() {
      var url = vpCheckoutApi(path);
      return fetch(url, {
        method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(body), signal: controller.signal, credentials: 'omit'
      }).then(null, function() { throw vpCheckoutError(VP_CHECKOUT_TEXT.offline, label + ' unreachable'); });
    }).then(function(response) {
      return response.json().catch(function() { return null; }).then(function(data) {
        if (!response.ok) {
          var error = vpCheckoutError((data && typeof data.message === 'string' && data.message) || VP_CHECKOUT_TEXT.busy, label + ' HTTP ' + response.status);
          error.httpStatus = response.status;
          if (data && typeof data.error === 'string') error.vpCode = data.error;
          if (data && data.details && typeof data.details === 'object') error.vpDetails = data.details;
          throw error;
        }
        if (!data || typeof data !== 'object') throw vpCheckoutError(VP_CHECKOUT_TEXT.busy, label + ' unreadable answer');
        return data;
      });
    }).then(function(data) { clearTimeout(timer); resolve(data); }, function(error) { clearTimeout(timer); reject(error); });
  });
}

function vpCheckoutItems(items) {
  return items.map(function(item) {
    return {
      name: item.name, qty: item.qty, unitPrice: item.unitPrice, total: item.total,
      cat: item.cat || (item.configuration && item.configuration.cat) || (cartItemIsJarCase(item) ? 'jars' : undefined),
      configuration: item.configuration || null,
      properties: cartNativeProperties(item)
    };
  });
}

function vpCheckoutPrice(items) {
  var body = { items: vpCheckoutItems(items) };
  var w = vpWelcomeBody();
  if (w) body.welcome = w;
  var o = vpBulkOrderBody();
  if (o) body.order = o;
  return vpCheckoutRequest('/api/checkout/price', body, 'Price check', 30000)
    .then(function(data) {
      if (vpShipKnown(data)) { vpShipRemember(vpShipSig(items), data.shipping); vpShip.welcome = { sig: vpShipSig(items), data: data.welcome || null }; vpShip.deal = { sig: vpShipSig(items), data: data.deal || null }; }
      return data;
    });
}

// Shipping line in the cart (Josh 10/11): free when the checkout server says the cart qualifies (die-cut
// only, $300+), otherwise picked at checkout. Asked once per cart (POST /api/checkout/price, no writes),
// kept for this tab.
var vpShip = { sig: null, mode: 'checkout', busy: null, failSig: null, failAt: 0, welcome: null, deal: null };
var VP_SHIP_RETRY_MS = 30000;   // a check that failed is asked again on a later refresh, never in a loop
var VP_SHIP_TEXT = { free: 'Shipping is free on this order; any tax is added at checkout.', checkout: 'Choose your shipping at checkout; any tax is added there.' };
function vpShipSig(items) {
  try {
    var w = vpWelcomeBody();   // the welcome code changes what the server answers for this cart
    var lines = (items || []).map(function(it) { return [it.name, it.qty, it.unitPrice, it.total, it.cat || null, it.configuration || null]; });
    var o = vpBulkOrderBody();   // the form's rush changes the server's answer too
    if (o) lines = lines.concat([['order', o]]);
    return JSON.stringify(w ? lines.concat([['welcome', w.code]]) : lines);
  }
  catch (e) { return null; }
}
function vpShipKnown(data) { return !!data && (data.shipping === 'free' || data.shipping === 'checkout'); }
function vpShipRemember(sig, mode) {
  vpShip.sig = sig; vpShip.mode = mode === 'free' ? 'free' : 'checkout';
  try { sessionStorage.setItem('vp_ship_mode', JSON.stringify({ sig: sig, mode: vpShip.mode, at: Date.now() })); } catch (e) {}
}
function vpShipText() {
  var sig = vpShipSig(cartItems);
  if (sig && sig !== vpShip.sig) {
    try {
      var c = JSON.parse(sessionStorage.getItem('vp_ship_mode') || 'null');
      if (c && c.sig === sig && Date.now() - c.at < 600000) { vpShip.sig = sig; vpShip.mode = c.mode === 'free' ? 'free' : 'checkout'; }
    } catch (e) {}
  }
  return VP_SHIP_TEXT[sig && sig === vpShip.sig ? vpShip.mode : 'checkout'];
}
function vpShipRefresh() {
  var sig = vpShipSig(cartItems);
  var welcomeKnown = !vpWelcomeBody() || (vpShip.welcome && vpShip.welcome.sig === sig);
  if (!sig || !cartItems.length || (sig === vpShip.sig && welcomeKnown) || vpShip.busy === sig || cartHasNativeJarLabels() || isLocalCheckoutPreview()) return;
  if (vpShip.failSig === sig && Date.now() - vpShip.failAt < VP_SHIP_RETRY_MS) return;
  vpShip.busy = sig;
  var body = { items: vpCheckoutItems(cartItems) };
  var w = vpWelcomeBody();
  if (w) body.welcome = w;
  var o = vpBulkOrderBody();
  if (o) body.order = o;
  vpCheckoutRequest('/api/checkout/price', body, 'Price check', 15000)
    .then(function(data) { if (!vpShipKnown(data)) throw new Error('no shipping answer'); vpShipRemember(sig, data.shipping); vpShip.welcome = { sig: sig, data: data.welcome || null }; vpShip.deal = { sig: sig, data: data.deal || null }; return true; })
    .then(null, function() {
      vpShip.failSig = sig; vpShip.failAt = Date.now();
      if (w) vpShip.welcome = { sig: sig, data: { ok: false, message: 'Your code is checked again when you continue to payment.' } };
      return true;
    })   // unknown: "chosen at checkout" for now, asked again later
    .then(function(known) { vpShip.busy = null; if (known && !_cartCheckingOut && vpShipSig(cartItems) === sig) refreshCartCheckoutUI(); });
}

function vpStagedTarget(target) {
  var url = new URL(target && target.url);
  if (url.protocol !== 'https:' || url.hostname !== 'shopify-staged-uploads.storage.googleapis.com' ||
      url.username || url.password || url.port || !target.resourceUrl || !Array.isArray(target.parameters)) {
    throw new Error('The artwork upload address is invalid.');
  }
  return url.href;
}

// Shopify's file CDN re-encodes or refuses picture bytes it can read (TIFF, PSD, HEIC, a PNG over Shopify's image
// limits...), so Command could not download the customer's original (overnight test 10/17, orders #4141-#4143). Those
// files are stored as "<name>.<ext>.bin" with the 16-byte VINYLPAC-RAWPNG tag in front: the CDN then serves them byte
// for byte, and Command strips the tag. PNG/JPG/WebP within Shopify's image limits stay MediaImages (their
// originalSource is the exact upload).
var VP_RAW_TAG = 'VINYLPAC-RAWPNG\n';
var VP_PICTURE_EXT = /^(png|jpe?g|webp|gif|tiff?|psd|psb|heic|heif|bmp|avif|jp2|jpx|ico|dng|cr2|nef|arw)$/i;
function vpPixels(buf) {
  var d = new DataView(buf), n = buf.byteLength;
  if (n > 24 && d.getUint32(0) === 0x89504e47) return { w: d.getUint32(16), h: d.getUint32(20) };
  if (n > 30 && d.getUint32(0) === 0x52494646 && d.getUint32(8) === 0x57454250) {
    var c = d.getUint32(12);
    if (c === 0x56503858) return { w: 1 + (d.getUint8(24) | d.getUint8(25) << 8 | d.getUint8(26) << 16), h: 1 + (d.getUint8(27) | d.getUint8(28) << 8 | d.getUint8(29) << 16) };
    if (c === 0x5650384c) { var bits = d.getUint32(21, true); return { w: 1 + (bits & 0x3fff), h: 1 + ((bits >>> 14) & 0x3fff) }; }
    if (c === 0x56503820) return { w: d.getUint16(26, true) & 0x3fff, h: d.getUint16(28, true) & 0x3fff };
    return null;
  }
  if (n > 4 && d.getUint16(0) === 0xffd8) {
    var i = 2;
    while (i + 9 < n) {
      if (d.getUint8(i) !== 0xff) { i++; continue; }
      var m = d.getUint8(i + 1);
      if (m === 0xff) { i++; continue; }
      if (m >= 0xc0 && m <= 0xcf && m !== 0xc4 && m !== 0xc8 && m !== 0xcc) return { w: d.getUint16(i + 7), h: d.getUint16(i + 5) };
      if (m === 0x01 || (m >= 0xd0 && m <= 0xd8)) { i += 2; continue; }
      i += 2 + d.getUint16(i + 2);
    }
  }
  return null;
}
function vpNeedsRawTag(file, head) {
  var ext = String(file.name || '').split('.').pop();
  var type = String(file.mimeType || '').toLowerCase();
  if (!((/^image\//.test(type) && !/svg/.test(type)) || VP_PICTURE_EXT.test(ext))) return false;
  if (!/^image\/(png|jpeg|webp)$/.test(type)) return true;
  var px = head ? vpPixels(head) : null;
  return !px || px.w * px.h > 20000000 || px.w > 20 * px.h || px.h > 20 * px.w;   // unknown size: tag it (Astra 10/17)
}
function vpRawWrapFiles(files) {
  return Promise.all(files.map(function(file) {
    var head = file.blob && typeof file.blob.slice === 'function' && typeof file.blob.slice(0, 1).arrayBuffer === 'function'
      ? file.blob.slice(0, 262144).arrayBuffer().catch(function() { return null; }) : Promise.resolve(null);
    return head.then(function(buf) {
      if (!vpNeedsRawTag(file, buf)) return file;
      var blob = new Blob([VP_RAW_TAG, file.blob], { type: 'application/octet-stream' });
      return Object.assign({}, file, { name: file.name + '.bin', mimeType: 'application/octet-stream', size: blob.size, blob: blob });
    });
  }));
}

// One artwork file to Shopify's upload storage. Josh 10/29: an XHR, so a waiting tap can show how far it is (onBytes);
// one that never reached the storage (no XHR, or a browser refusing its CORS check) goes again by fetch as before (the
// same form to the same staged target again is harmless). -> Promise<{ ok, status }>; AbortError on the 5-minute limit.
function vpStagedPost(url, form, onBytes) {
  function viaFetch() {
    var controller = new AbortController();
    var timer = setTimeout(function() { controller.abort(); }, 300000);
    return fetch(url, { method: 'POST', body: form, signal: controller.signal, credentials: 'omit' }).then(function(response) {
      clearTimeout(timer);
      return { ok: response.ok, status: response.status };
    }, function(error) { clearTimeout(timer); throw error; });
  }
  if (typeof XMLHttpRequest !== 'function') return viaFetch();
  return new Promise(function(resolve, reject) {
    var x = new XMLHttpRequest();
    x.open('POST', url);
    x.timeout = 300000;
    if (onBytes && x.upload) x.upload.onprogress = function(e) { if (e.lengthComputable && e.total > 0) onBytes(e.loaded, e.total); };
    x.onload = function() { resolve({ ok: x.status >= 200 && x.status < 300, status: x.status }); };
    x.onerror = function() { if (onBytes) onBytes(0, 1); resolve(viaFetch()); };
    x.ontimeout = function() { var e = new Error('Artwork upload timed out.'); e.name = 'AbortError'; reject(e); };
    x.send(form);
  });
}

// Every file must be accepted by Shopify's upload storage before the draft. onBytes(name, sent, total): how far.
function vpCheckoutUpload(orderRef, files, onBytes) {
  return vpCheckoutRequest('/api/checkout/uploads', {
    orderRef: orderRef,
    files: files.map(function(file) { return { key: file.key, name: file.name, mimeType: file.mimeType, size: file.size }; })
  }, 'Artwork upload service', 30000).then(function(data) {
    var targets = data.targets || {};
    var urls = files.map(function(file) { return vpStagedTarget(targets[file.key]); });
    if (new Set(files.map(function(file) { return targets[file.key].resourceUrl; })).size !== files.length) throw new Error('The artwork upload addresses are incomplete.');
    return Promise.all(files.map(function(file, i) {
      var target = targets[file.key];
      var form = new FormData();
      target.parameters.forEach(function(p) { form.append(p.name, p.value); });
      form.append('file', file.blob, target.name || file.name);
      var bytes = onBytes ? function(sent, total) { onBytes(file.key, Math.round(file.size * sent / total), file.size); } : null;
      if (bytes) bytes(0, 1);
      return vpStagedPost(urls[i], form, bytes).then(function(response) {
        if (!response.ok) throw new Error('Artwork upload was not confirmed (HTTP ' + response.status + ').');
        if (bytes) bytes(1, 1);
        return { key: file.key, resourceUrl: target.resourceUrl, name: target.name || file.name, mimeType: file.mimeType, size: file.size };
      }, function(error) {
        throw new Error(error && error.name === 'AbortError' ? 'Artwork upload timed out.' : 'Artwork upload failed. Check your connection.');
      });
    })).then(function(confirmed) {
      var uploads = {};
      confirmed.forEach(function(c) { uploads[c.key] = c; });
      if (Object.keys(uploads).length !== files.length) throw new Error('Not every artwork file was confirmed.');
      return { uploads: uploads };
    });
  });
}

// One entry per cart item: raw configuration (for server re-pricing), the
// properties the shop reads, and its Shopify upload refs (body/lid/ring).
function vpCheckoutDraftBody(items, uploads, key, orderRef, pre, artToken) {
  var lines = vpCheckoutItems(items);
  Object.keys(uploads || {}).forEach(function(k) {
    var m = /^(body|lid|ring)_(\d+)$/.exec(k);
    if (!m || !lines[Number(m[2])]) throw new Error('The artwork uploads do not match the cart.');
    var line = lines[Number(m[2])];
    line.files = line.files || {};
    line.files[m[1]] = { resourceUrl: uploads[k].resourceUrl, name: uploads[k].name, mimeType: uploads[k].mimeType, size: uploads[k].size };
  });
  // Josh 10/18: artwork already in Shopify Files (uploaded when the design was added to the cart, vp-art.js) goes as
  // its file id; the server verifies it by id with this tab's token before any draft exists.
  Object.keys(pre || {}).forEach(function(k) {
    var m = /^(body|lid|ring)_(\d+)$/.exec(k);
    if (!m || !lines[Number(m[2])]) throw new Error('The saved artwork does not match the cart.');
    var line = lines[Number(m[2])];
    line.files = line.files || {};
    line.files[m[1]] = { fileId: pre[k].id, name: pre[k].name, mimeType: pre[k].mimeType, size: pre[k].size };
  });
  var body = { key: key, orderRef: orderRef, items: lines };
  if (artToken && Object.keys(pre || {}).length) body.artToken = artToken;
  var w = vpWelcomeBody();
  if (w) body.welcome = w;   // the server checks it again and refuses (never charges full price) if it can't be used
  var o = vpBulkOrderBody();
  if (o) body.order = o;      // Bulk Order Form: rush, mockups, Instagram, notes (the server checks them again)
  else if (vpMockupsApplies()) body.mockups = vpMockupsWanted();   // the cart's own mockups box (Josh 10/18)
  var b = window.VP_BUYER;   // signed-in customer from the theme head (null for guests); the server verifies it
  if (b && typeof b === 'object' && b.id && b.email && b.iat && b.sig) body.buyer = { id: String(b.id), email: String(b.email), iat: String(b.iat), sig: String(b.sig) };
  if (window.VP_CHECKOUT_TEST === true) body.test = true; // honored only by a dev server with ALLOW_TEST_DRAFTS=1
  var tk = vpTeamTestKey();
  if (tk) body.teamTest = tk;   // the server checks it; a stale key is refused, never charged
  return body;
}

// Bulk Order Form (Josh 10/17: "recreate my own version [of the Jotform] ... they can check if they want mockups or not
// on their way out"). bulk-order.html saves its designs as ordinary builder lines (configuration.bulkForm) and its
// order-level answers in sessionStorage vp_cart_order; they go with the price check and the draft while the cart still
// holds one of the form's lines. Rush (size-price skill, Josh 10/11): 15% of the products, $50 minimum, its own line.
var VP_BULK_ORDER_STORE = 'vp_cart_order';
function vpBulkOrderBody() {
  try {
    if (!(cartItems || []).some(function(it) { return it && it.configuration && it.configuration.bulkForm; })) return null;
    var o = JSON.parse(sessionStorage.getItem(VP_BULK_ORDER_STORE) || 'null');
    if (!o || o.version !== 1 || o.form !== 'bulk-order' || o.terms !== true) return null;
    return { version: 1, form: 'bulk-order', name: String(o.name || ''), email: String(o.email || ''), rush: o.rush === true, needBy: o.rush === true ? String(o.needBy || '') : '', mockups: o.mockups === true,
      instagram: String(o.instagram || ''), share: o.share === 'yes' || o.share === 'no' ? o.share : '', info: String(o.info || ''), terms: true };
  } catch (e) { return null; }
}
function vpBulkRushCents() {
  var o = vpBulkOrderBody();
  if (!o || !o.rush) return 0;
  var sub = 0;
  cartItems.forEach(function(it) { sub += Math.round((parseFloat(it.total) || 0) * 100); });
  return Math.max(5000, Math.round(sub * 0.15));
}
function vpBulkNiceDate(ymd) {
  var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || '');
  if (!m) return '';
  return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
}
function vpBulkRender(footer) {
  var row = footer.querySelector ? footer.querySelector('.cart-total-row') : null;
  if (!row || !row.parentNode) return;
  var box = document.getElementById('vpBulkBox');
  if (!box) {
    box = document.createElement('div');
    box.id = 'vpBulkBox';
    box.className = 'vp-welcome-box';
    row.parentNode.insertBefore(box, row.nextSibling);
  }
  vpWelcomeCss();
  var o = isLocalCheckoutPreview() ? null : vpBulkOrderBody();
  var html = '';
  if (o) {
    var rush = vpBulkRushCents();
    if (o.rush) html += '<div class="vp-welcome-row"><span>Rush order <b>need by ' + escHtml(vpBulkNiceDate(o.needBy)) + '</b></span><span class="vp-welcome-amt">$' + (rush / 100).toFixed(2) + '</span></div>';
    // The welcome box shows the Total when a code applies; otherwise this one does.
    var w = vpWelcomeActive();
    var sig = vpShipSig(cartItems);
    var ans = w && vpShip.welcome && vpShip.welcome.sig === sig ? vpShip.welcome.data : null;
    if (o.rush && !(ans && ans.ok && Number(ans.amount) > 0)) {
      var sub = 0;
      cartItems.forEach(function(it) { sub += Math.round((parseFloat(it.total) || 0) * 100); });
      html += '<div class="vp-welcome-row vp-welcome-total"><span><b>Total</b></span><span class="vp-welcome-amt">$' + (Math.max(0, sub + rush - vpDealCents()) / 100).toFixed(2) + '</span></div>';
    }
  }
  if (box.innerHTML !== html) box.innerHTML = html;
}

// Mockups (Josh 10/18: "mockups will be sent in less than 12 hours to their email for approval" + "make it optional to
// have them or not"). Ticked by default: every website order was proofed before the box. Command reads the draft's
// "Mockups Before Printing"; a No gets no proof unless Josh asks. A cart holding the Bulk Order Form's lines shows the
// form's answer here and a change goes back into it (one answer per order). Blank jar cases alone get no box.
var VP_MOCKUPS_STORE = 'vp_mockups';   // sessionStorage, beside the cart (vp_cart)
function vpMockupsApplies() {
  return (cartItems || []).some(function(it) { return it && !cartItemIsJarCase(it); });
}
function vpMockupsWanted() {
  var o = vpBulkOrderBody();
  if (o) return o.mockups;
  try { return sessionStorage.getItem(VP_MOCKUPS_STORE) !== 'no'; } catch (e) { return true; }
}
function vpMockupsSet(on) {
  try {
    if (vpBulkOrderBody()) {
      var o = JSON.parse(sessionStorage.getItem(VP_BULK_ORDER_STORE) || 'null');
      o.mockups = !!on;
      sessionStorage.setItem(VP_BULK_ORDER_STORE, JSON.stringify(o));
    } else if (on) sessionStorage.removeItem(VP_MOCKUPS_STORE);
    else sessionStorage.setItem(VP_MOCKUPS_STORE, 'no');
  } catch (e) {}
}
function vpMockupsRender(footer, help) {
  var box = document.getElementById('vpMockupsBox');
  if (!box) {
    if (!help || help.parentNode !== footer) return;
    box = document.createElement('label');
    box.id = 'vpMockupsBox';
    box.className = 'vp-mock';
    box.innerHTML = '<input type="checkbox" id="vpMockups"><span>Send me mockups before printing<small>Sent to your email for approval in less than 12 hours.</small></span>';
    footer.insertBefore(box, help);
    box.querySelector('input').addEventListener('change', function(e) {
      if (_cartCheckingOut) { e.target.checked = vpMockupsWanted(); return; }   // never changes a checkout under way
      vpMockupsSet(e.target.checked);
      refreshCartCheckoutUI();
    });
  }
  vpMockupsCss();
  box.hidden = cartHasNativeJarLabels() || !vpMockupsApplies();
  box.querySelector('input').checked = vpMockupsWanted();
}
function vpMockupsCss() {
  if (!document.head || document.getElementById('vpMockupsCss')) return;
  var css = document.createElement('style');
  css.id = 'vpMockupsCss';
  // the Bulk Order Form's tick box (bulk-order.css .bo-check)
  css.textContent =
    '.vp-mock{display:flex;align-items:flex-start;gap:11px;cursor:pointer;font-size:14px;line-height:1.5;color:#242424}' +
    '.vp-mock[hidden]{display:none}' +
    '.vp-mock input{appearance:none;-webkit-appearance:none;flex-shrink:0;width:20px;height:20px;margin:1px 0 0;border:1px solid #aaa;border-radius:5px;background:#fff;cursor:pointer;position:relative}' +
    '.vp-mock input:checked{background:#242424;border-color:#242424}' +
    '.vp-mock input:checked:after{content:"";position:absolute;left:6px;top:2px;width:5px;height:10px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}' +
    '.vp-mock input:focus-visible{outline:2px solid #242424;outline-offset:3px}' +
    '.vp-mock small{display:block;color:#777;font-size:12px;line-height:1.5;margin-top:3px}';
  document.head.appendChild(css);
}

// Team test mode (Josh 10/15: "add orders and totals but when we check out its 0 dollars"). The theme shim
// (tools/theme-src/vp-shim.js, on every page) turns it on from ?vptest=<team key> and shows the badge. Prices
// and totals stay real; Shopify's checkout is $0 (the server adds a 100% discount and $0 shipping).
var VP_TEAM_TEST_STORE = 'vp_team_test';
function vpTeamTestKey() {
  try {
    var k = localStorage.getItem(VP_TEAM_TEST_STORE) || '';
    return /^[A-Za-z0-9_-]{16,128}$/.test(k) ? k : '';
  } catch (e) { return ''; }
}

// Welcome code (Josh 10/15: "subscribe to the site and get 15% off your first order (stickers and labels only
// excludes jars)"). The site pop-up (welcome-popup.js) keeps {code, email} in localStorage vp_welcome; the cart
// sends it with the price check and the draft, and the server takes 15% off sticker/label lines (never jars).
// The code is part of the cart identity, so adding or removing it never resumes the other checkout.
var VP_WELCOME_STORE = 'vp_welcome';
var VP_WELCOME_RE = /^VP15-[2-9A-HJKMNP-Z]{6}$/;
var vpWelcomeUi = { open: false, error: '' };
function vpWelcomeActive() {
  try {
    var w = JSON.parse(localStorage.getItem(VP_WELCOME_STORE) || 'null');
    if (!w || w.off || typeof w.code !== 'string' || !VP_WELCOME_RE.test(w.code)) return null;
    return { code: w.code, email: typeof w.email === 'string' && w.email ? w.email : null };
  } catch (e) { return null; }
}
function vpWelcomeBody() {
  var w = vpWelcomeActive();   // team test carts too (Sue 10/15): the code shows its real discount there
  return w ? (w.email ? { code: w.code, email: w.email } : { code: w.code }) : null;
}
function vpWelcomeStore(w) {
  try { localStorage.setItem(VP_WELCOME_STORE, JSON.stringify(w)); return true; } catch (e) { return false; }
}
function vpWelcomeChanged() {
  vpShip.sig = null;   // ask the server again for this cart (shipping + the code's discount)
  vpWelcomeUi.error = '';
  try { var s = document.getElementById('cartCheckoutStatus'); if (s && /welcome code/i.test(s.textContent)) cartCheckoutStatus('', false); } catch (e) {}
  if (!_cartCheckingOut) refreshCartCheckoutUI();
}
function vpWelcomeApply(raw) {
  var code = String(raw || '').trim().toUpperCase().replace(/\s+/g, '');
  if (!code) { vpWelcomeUi.error = 'Enter your code first.'; refreshCartCheckoutUI(); return; }
  if (!VP_WELCOME_RE.test(code)) { vpWelcomeUi.error = "That code isn't valid. VINYLPAC codes look like VP15-ABC234."; refreshCartCheckoutUI(); return; }
  var old = null;
  try { old = JSON.parse(localStorage.getItem(VP_WELCOME_STORE) || 'null'); } catch (e) {}
  var email = old && old.code === code && old.email ? old.email : null;
  if (!vpWelcomeStore({ code: code, email: email, at: Date.now() })) { vpWelcomeUi.error = 'Browser storage is off, so the code can\'t be saved here.'; refreshCartCheckoutUI(); return; }
  vpWelcomeUi.open = false;
  vpWelcomeChanged();
}
function vpWelcomeRemove() {
  var w = null;
  try { w = JSON.parse(localStorage.getItem(VP_WELCOME_STORE) || 'null'); } catch (e) {}
  vpWelcomeStore(Object.assign({}, w || {}, { off: true, at: Date.now() }));   // the pop-up stays closed; the code can be typed again
  vpWelcomeChanged();
}
// Monthly deals (Josh 10/31, the deals page /?view=deals). The checkout server says which cart lines a deal covers and
// what comes off (POST /api/checkout/price `deal`, switch DEALS); the cart shows each saving and the total after it,
// exactly what Shopify's page will charge. Nothing here decides a deal: no answer for this cart = no deal rows.
function vpDealAnswer() {
  var sig = vpShipSig(cartItems);
  var d = vpShip.deal && vpShip.deal.sig === sig ? vpShip.deal.data : null;
  return d && Array.isArray(d.lines) && d.lines.length && Number(d.amount) > 0 ? d : null;
}
function vpDealCents() {
  var d = isLocalCheckoutPreview() ? null : vpDealAnswer();
  return d ? Math.round(Number(d.amount) * 100) : 0;
}
function vpDealRender(footer) {
  var row = footer.querySelector ? footer.querySelector('.cart-total-row') : null;
  if (!row || !row.parentNode) return;
  var box = document.getElementById('vpDealBox');
  if (!box) {
    box = document.createElement('div');
    box.id = 'vpDealBox';
    box.className = 'vp-welcome-box';
    box.setAttribute('aria-live', 'polite');
    row.parentNode.insertBefore(box, row.nextSibling);
  }
  vpWelcomeCss();
  var d = isLocalCheckoutPreview() || cartHasNativeJarLabels() || !cartItems.length ? null : vpDealAnswer();
  var html = '';
  if (d) {
    d.lines.forEach(function(l) {
      html += '<div class="vp-welcome-row"><span>' + escHtml(String(l.title || 'Deal')) + ' <b>Design ' + escHtml(String(l.design)) + '</b></span>' +
        '<span class="vp-welcome-amt">−$' + (Math.round(Number(l.amount) * 100) / 100).toFixed(2) + '</span></div>';
    });
    // The welcome box (a code that applies) or the Bulk Order Form's rush row shows the Total instead.
    var w = vpWelcomeActive(), sig = vpShipSig(cartItems);
    var ans = w && vpShip.welcome && vpShip.welcome.sig === sig ? vpShip.welcome.data : null;
    var o = vpBulkOrderBody();
    if (!(ans && ans.ok && Number(ans.amount) > 0) && !(o && o.rush)) {
      var sub = 0;
      cartItems.forEach(function(it) { sub += Math.round((parseFloat(it.total) || 0) * 100); });
      html += '<div class="vp-welcome-row vp-welcome-total"><span><b>Total</b></span><span class="vp-welcome-amt">$' + (Math.max(0, sub - vpDealCents()) / 100).toFixed(2) + '</span></div>';
    }
  }
  if (box.innerHTML !== html) box.innerHTML = html;
}

function vpWelcomeCss() {
  if (!document.head || document.getElementById('vpWelcomeCss')) return;
  var css = document.createElement('style');
  css.id = 'vpWelcomeCss';
  css.textContent =
    '.vp-welcome-box{display:grid;gap:6px;font-size:13px;line-height:1.45;color:#444}' +
    '.vp-welcome-box:empty{display:none}' +
    '.vp-welcome-row{display:flex;justify-content:space-between;align-items:baseline;gap:12px}' +
    '.vp-welcome-row b{font-weight:600;color:#111}' +
    '.vp-welcome-amt{font-weight:700;color:#111;white-space:nowrap}' +
    '.vp-welcome-total .vp-welcome-amt{font-size:18px}' +
    '.vp-welcome-link{background:none;border:0;padding:0;font:inherit;font-size:13px;color:#111;text-decoration:underline;text-underline-offset:2px;cursor:pointer;justify-self:start}' +
    '.vp-welcome-form{display:flex;gap:8px}' +
    '.vp-welcome-form input{flex:1;min-width:0;height:40px;padding:0 12px;border:1px solid #c9c9c9;border-radius:10px;font:inherit;font-size:15px;text-transform:uppercase;letter-spacing:.04em;background:#fff;color:#111}' +
    '.vp-welcome-form input:focus{outline:none;border-color:#111;box-shadow:0 0 0 3px rgba(17,17,17,.12)}' +
    '.vp-welcome-form button{height:40px;padding:0 16px;border:0;border-radius:10px;background:#111;color:#fff;font:inherit;font-size:14px;font-weight:600;cursor:pointer}' +
    '.vp-welcome-err{margin:0;font-size:12px;color:#b42318}';
  document.head.appendChild(css);
}
function vpWelcomeRender(footer) {
  var row = footer.querySelector ? footer.querySelector('.cart-total-row') : null;
  if (!row || !row.parentNode) return;
  var box = document.getElementById('vpWelcomeBox');
  if (!box) {
    box = document.createElement('div');
    box.id = 'vpWelcomeBox';
    box.className = 'vp-welcome-box';
    box.setAttribute('aria-live', 'polite');
    row.parentNode.insertBefore(box, row.nextSibling);
  }
  vpWelcomeCss();
  if (isLocalCheckoutPreview() || cartHasNativeJarLabels() || !cartItems.length) { box.innerHTML = ''; return; }
  var w = vpWelcomeActive();
  var sig = vpShipSig(cartItems);
  var ans = w && vpShip.welcome && vpShip.welcome.sig === sig ? vpShip.welcome.data : null;
  var html = '';
  var remove = '<button type="button" class="vp-welcome-link" data-vp-welcome="remove">Remove code</button>';
  // Sue 10/15 ("Where do I enter the code?"): the Discount code field is always there under the total, never
  // behind a link. The field keeps what was typed across re-renders (the cart redraws often).
  var input0 = box.querySelector('input');
  var typed = input0 ? input0.value : '';
  var forEmail = ans && ans.ok && ans.email ? '<p style="margin:0">For ' + escHtml(String(ans.email)) + '. Checkout uses this email.</p>' : '';
  if (!w) {
    html = '<form class="vp-welcome-form" data-vp-welcome="form" novalidate>' +
      '<input type="text" name="code" aria-label="Discount code" placeholder="Discount code" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="20">' +
      '<button type="submit">Apply</button></form>' +
      (vpWelcomeUi.error ? '<p class="vp-welcome-err" role="alert">' + escHtml(vpWelcomeUi.error) + '</p>' : '');
  } else if (!ans) {
    html = '<div class="vp-welcome-row"><span>Discount code <b>' + escHtml(w.code) + '</b></span><span>Checking…</span></div>' + remove;
  } else if (ans.ok && Number(ans.amount) > 0) {
    var sub = 0;
    cartItems.forEach(function(it) { sub += Math.round((parseFloat(it.total) || 0) * 100); });
    var off = Math.round(Number(ans.amount) * 100);
    html = '<div class="vp-welcome-row"><span>15% off stickers &amp; labels <b>' + escHtml(w.code) + '</b></span><span class="vp-welcome-amt">−$' + (off / 100).toFixed(2) + '</span></div>' +
      '<div class="vp-welcome-row vp-welcome-total"><span><b>Total</b></span><span class="vp-welcome-amt">$' + (Math.max(0, sub + vpBulkRushCents() - vpDealCents() - off) / 100).toFixed(2) + '</span></div>' + forEmail + remove;
  } else {
    html = '<div class="vp-welcome-row"><span>Discount code <b>' + escHtml(w.code) + '</b></span></div>' +
      '<p style="margin:0">' + escHtml(String(ans.message || '')) + '</p>' + forEmail + remove;
  }
  if (box.innerHTML !== html) {
    box.innerHTML = html;
    var input1 = box.querySelector('input');
    if (input1 && typed) input1.value = typed;
  }
  if (!box.vpWired) {
    box.vpWired = true;
    box.addEventListener('click', function(e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-vp-welcome]') : null;
      if (!t || _cartCheckingOut) return;
      var what = t.getAttribute('data-vp-welcome');
      if (what === 'open') {
        vpWelcomeUi.open = true; vpWelcomeUi.error = ''; refreshCartCheckoutUI();
        var input = box.querySelector('input'); if (input) input.focus();
      } else if (what === 'remove') vpWelcomeRemove();
    });
    box.addEventListener('submit', function(e) {
      e.preventDefault();
      if (_cartCheckingOut) return;
      var input = box.querySelector('input');
      vpWelcomeApply(input ? input.value : '');
    });
  }
}
if (typeof window !== 'undefined' && window.addEventListener) {
  // The pop-up just handed out a code (this tab or another one): show it in the cart.
  window.addEventListener('vp-welcome', function() { try { vpWelcomeChanged(); } catch (e) {} });
  window.addEventListener('storage', function(e) { if (e && e.key === VP_WELCOME_STORE) { try { vpWelcomeChanged(); } catch (x) {} } });
}

// A checkout whose answer never arrived (lost connection, closed tab), or a saved payment link: the server
// knows what happened to its key. ready = the draft exists, resume it; none = nothing was made, or its draft
// is gone (unpaid drafts are deleted after 30 days), start again; anything else (still being confirmed,
// service unreachable) keeps the saved state and its message. Nothing saved: no request at all.
function vpCheckoutReconcile(saved) {
  if (!saved || !/^(creating|ready)$/.test(saved.status) || !/^[a-f0-9]{64}$/.test(String(saved.key || ''))) return Promise.resolve();
  return vpCheckoutRequest('/api/checkout/status', { key: saved.key }, 'Checkout status', 20000).then(function(data) {
    if (data.status === 'ready' && data.draftStatus === 'COMPLETED') {
      // Already paid (Sue 10/15): never send the buyer to a paid checkout again; the cart empties.
      if (window.vpCartClearPaid) { if (window.vpCartClearPaid(saved.key)) return 'paid'; }
      else { vpCartPaidReset(); return 'paid'; }
    }
    if (data.status === 'ready' && data.invoiceUrl && data.draftId) {
      // A draft found by /status may be seconds old (a lost answer): count it as made now.
      writeSavedCheckout({ version: 1, key: saved.key, cart: saved.cart, orderRef: saved.orderRef, status: 'ready',
        url: checkoutPaymentUrl(data.invoiceUrl), draftId: String(data.draftId), madeAt: saved.madeAt || Date.now() });
    } else if (data.status === 'none') {
      forgetSavedCheckout();
    }
  }, function() { /* unknown: keep the safe message */ });
}

// A paid checkout empties the cart (Sue 10/15). The theme shim (vp-shim.js vpCartClearPaid) clears the stored
// cart once Shopify says the saved checkout's draft is paid, then calls this for the cart already in memory.
function vpCartPaidReset() {
  if (_cartEditing) { try { cancelCartEdit(true); } catch (e) {} }
  _savedCheckoutMemory = null;
  try { sessionStorage.removeItem(CHECKOUT_STORAGE_KEY); } catch (e) {}
  vpWarmWrite(null);   // a background draft of the paid cart is never handed out (Josh 10/19)
  cartItems = [];
  cartCount = 0;
  currentOrderRef = null;   // the next cart is a new order (new ref, new key)
  try { saveCart(); } catch (e) {}
  try { updateCartBadge(); } catch (e) {}
  if (!_cartCheckingOut) { try { renderCartDrawer(); } catch (e) {} }
}
if (typeof window !== 'undefined') window.vpCartPaidReset = vpCartPaidReset;

// ── The calm hand-off (Josh 10/12) ──────────────────────────────────────────
function vpCheckoutCss() {
  if (!document.head || document.getElementById('vpCheckoutCss')) return;
  var css = document.createElement('style');
  css.id = 'vpCheckoutCss';
  css.textContent =
    '.cart-btn-checkout.vp-going::before{content:"";display:inline-block;box-sizing:border-box;width:.9em;height:.9em;margin-right:.6em;' +
    'vertical-align:-.1em;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:vp-going-spin .8s linear infinite}' +
    '@keyframes vp-going-spin{to{transform:rotate(360deg)}}' +
    '@media (prefers-reduced-motion:reduce){.cart-btn-checkout.vp-going::before{display:none}}';
  document.head.appendChild(css);
}

// Screen readers hear the same state; the line itself takes no space in the drawer.
function vpCheckoutAnnounce(text) {
  var footer = document.getElementById('cartDrawerFooter');
  if (!footer) return;
  var live = document.getElementById('vpCheckoutLive');
  if (!live) {
    live = document.createElement('p');
    live.id = 'vpCheckoutLive';
    live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    footer.appendChild(live);
  }
  live.textContent = text;
}

// Open the connections the next steps need while the first requests run: Shopify's upload storage (the
// artwork POST spent 0.37 s on a new TLS connection) and shop.app (the Shop Pay check the payment link
// passes through on a first visit).
function vpCheckoutPreconnect() {
  if (vpCheckoutPreconnect.done || !document.head) return;
  vpCheckoutPreconnect.done = true;
  [['https://shopify-staged-uploads.storage.googleapis.com', true], ['https://shop.app', false]].forEach(function(p) {
    var link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = p[0];
    if (p[1]) link.crossOrigin = 'anonymous';   // the artwork POST is sent without credentials
    document.head.appendChild(link);
  });
}

function vpCheckoutBusy(button) {
  vpCheckoutCss();
  vpCheckoutPreconnect();
  if (button) {
    button.textContent = VP_CHECKOUT_TEXT.going;
    button.classList.add('vp-going');
  }
  vpWaitStart(button);
  vpCheckoutAnnounce(VP_CHECKOUT_TEXT.going);
}

// On the way to Shopify's payment page the cart stays locked and calm until this page is gone. Back from
// Shopify (Safari and Chrome restore this page from their back-forward cache: pageshow, persisted) or a page
// still here VP_LEAVE_WATCHDOG_MS later gives the cart back, with its saved checkout ("Resume payment").
// madeAt (this browser's clock when the Worker answered with a new draft) holds the leave until the draft is
// VP_DRAFT_SETTLE_MS old; the watchdog starts when the browser actually leaves.
function vpCheckoutLeave(url, madeAt) {
  vpWaitStage('');
  _vpLeaving = url;
  clearTimeout(vpCheckoutLeave.timer);
  var wait = typeof madeAt === 'number' ? Math.min(VP_DRAFT_SETTLE_MS, Math.max(0, madeAt + VP_DRAFT_SETTLE_MS - Date.now())) : 0;
  function go() {
    if (_vpLeaving !== url) return;   // the cart was given back meanwhile
    vpCheckoutLeave.timer = setTimeout(vpCheckoutBack, VP_LEAVE_WATCHDOG_MS);
    window.location.href = vpPayUrl(url);   // Josh 10/19: skip_shop_pay when the fast payment page is on
  }
  if (wait > 0) vpCheckoutLeave.timer = setTimeout(go, wait); else go();
  return true;
}

function vpCheckoutBack() {
  clearTimeout(vpCheckoutLeave.timer);
  if (!_vpLeaving) return;
  _vpLeaving = null;
  _cartCheckingOut = false;
  vpCheckoutAnnounce('');
  refreshCartCheckoutUI();
}

if (typeof window.addEventListener === 'function') {
  window.addEventListener('pagehide', function() { clearTimeout(vpCheckoutLeave.timer); });
  window.addEventListener('pageshow', function(event) { if (event && event.persisted) vpCheckoutBack(); });
}

// True when a canvas shows anything right now (a 24 px sample). Called in the same task as the frame that
// drew it, so a WebGL canvas without preserveDrawingBuffer still has its pixels. (Josh 10/12, #4100's cart:
// an empty grey thumbnail.)
function vpCanvasHasPixels(canvas) {
  try {
    var c = document.createElement('canvas');
    c.width = 24; c.height = 24;
    var ctx = c.getContext('2d');
    ctx.drawImage(canvas, 0, 0, 24, 24);
    var px = ctx.getImageData(0, 0, 24, 24).data;
    for (var i = 3; i < px.length; i += 4) if (px[i] > 8) return true;
    return false;
  } catch (e) { return true; }   // can't sample it: keep the image, as before
}

// Josh 10/18: artwork uploaded when the design was added to the cart (tools/theme-src/vp-art.js). null when the module
// is missing or off: then every request below is exactly as before.
var VP_ART_SETTLE_MS = 90000;   // how long the tap waits for an upload still running: the same bytes would otherwise go up
                                 // a second time on top of it (the draft request has the same 90 s)
var VP_ART_RETRY = { vpArtRetry: true };
function vpArtEarly() {
  var a = window.VPArtUpload;
  try { return a && typeof a.ready === 'function' && typeof a.active === 'function' && a.active() ? a : null; } catch (e) { return null; }
}
function vpArtLines(files, items) {
  return files.map(function(file) { return { itemId: items[file.item].id, part: file.part }; });
}
// The designs the server called stale (details.stale = [{design, part}]); without details, every line of this cart.
function vpArtStaleLines(error, items, files) {
  var d = error && error.vpDetails && Array.isArray(error.vpDetails.stale) ? error.vpDetails.stale : null;
  if (!d || !d.length) return vpArtLines(files, items);
  return d.filter(function(x) { return x && items[Number(x.design) - 1] && /^(body|lid|ring)$/.test(String(x.part)); })
    .map(function(x) { return { itemId: items[Number(x.design) - 1].id, part: String(x.part) }; });
}

// ── The cart's background checkout (Josh 10/19: "its taking a solid 5-8 seconds to load the cart to checkout … can
// we cut this down to like under a second") ─────────────────────────────────────────────────────────────────────────
// While the buyer looks at the cart, the cart sends the very /draft request the tap would send (warm: true) as soon
// as every design's artwork is in Shopify Files (vp-art.js) and the cart has been still for VP_WARM_DELAY_MS. The tap
// then finds a payment link for exactly this cart that is already old enough for Shopify (VP_DRAFT_SETTLE_MS) and
// leaves at once, once the server confirms the draft is the buyer's now (/claim). A cart that changes takes its
// old background draft back first (/discard: deleted, its files given back for the next draft). Off (theme setting
// vp_checkout_warm, ?vpwarm=), without vp-art.js, or with nothing made yet: the tap works exactly as before.
var VP_WARM_STORE = 'vp_checkout_warm';       // sessionStorage, this tab: { v, key, cart, orderRef, ship, url, draftId, madeAt }
var VP_WARM_DELAY_MS = typeof window.VP_WARM_DELAY_MS === 'number' ? window.VP_WARM_DELAY_MS : 1200;
var VP_WARM_MAX_AGE_MS = 2.5 * 3600 * 1000;   // the server deletes one nobody opened at 3 h (app.js WARM_TTL_MS)
var VP_WARM_ART_WAIT_MS = 120000;             // artwork still going up: wait this long, then look again
var vpWarm = { timer: null, busy: null, drafting: null, again: false, failed: {} };
function vpWarmOn() {
  try {
    var o = localStorage.getItem('vp_checkout_warm');
    if (o === 'on' || o === 'off') return o === 'on';
  } catch (e) {}
  return window.VP_CHECKOUT_WARM === 'on';
}
function vpWarmRead() {
  try {
    var w = JSON.parse(sessionStorage.getItem(VP_WARM_STORE) || 'null');
    return w && w.v === 1 && /^[a-f0-9]{64}$/.test(String(w.key)) && typeof w.cart === 'string' && typeof w.madeAt === 'number' ? w : null;
  } catch (e) { return null; }
}
function vpWarmWrite(w) {
  try { if (w) sessionStorage.setItem(VP_WARM_STORE, JSON.stringify(w)); else sessionStorage.removeItem(VP_WARM_STORE); } catch (e) {}
}
function vpWarmShip() { return JSON.stringify(loadPricing().shipping || {}); }
// This tab's background draft for exactly this cart (the same identity, order ref and shipping the tap's key hashes),
// young enough that the server still keeps it; null otherwise.
function vpWarmFor(identity) {
  var w = vpWarmRead();
  if (!w || !w.url || !w.draftId || w.cart !== identity || w.orderRef !== (currentOrderRef || 'ORD-0000')) return null;
  try { if (w.ship !== vpWarmShip()) return null; } catch (e) { return null; }
  return Date.now() - w.madeAt < VP_WARM_MAX_AGE_MS ? w : null;
}
// Every cart change and every look at the cart (refreshCartCheckoutUI) lands here; the work waits for a still cart.
function vpWarmSoon() {
  if (!vpWarmOn()) return;
  clearTimeout(vpWarm.timer);
  vpWarm.timer = setTimeout(vpWarmRun, VP_WARM_DELAY_MS);
}
function vpWarmRun() {
  if (vpWarm.busy) { vpWarm.again = true; return vpWarm.busy; }
  vpWarm.busy = vpWarmOnce().then(function(r) { return r; }, function(e) {
    if (window.console && console.warn) console.warn('[checkout] background', (e && e.vpLabel) || '', e && e.message || e);
  }).then(function(r) {
    vpWarm.busy = null;
    vpWarm.drafting = null;
    if (vpWarm.again || r === 'again') { vpWarm.again = false; vpWarmSoon(); }
  });
  return vpWarm.busy;
}
// The old background draft (another cart, or one too old to trust) goes before the next is made. A draft the server
// won't discard (already handed out, or not ours any more) is simply forgotten here.
function vpWarmDrop(identity) {
  var w = vpWarmRead();
  if (!w) return Promise.resolve(true);
  return vpCheckoutRequest('/api/checkout/discard', { key: w.key }, 'Background checkout', 20000).then(function(r) {
    if (vpWarmRead() && vpWarmRead().key === w.key) vpWarmWrite(null);
    var a = vpArtEarly();
    if (r && r.discarded && a) a.release(w.key);   // its files are free for the next draft
    return true;
  }, function(error) {
    // Refused: forgotten. No answer: forgotten too (Sol 10/19 r3: it may be deleted, so it is never handed out), and
    // nothing new is made this time; its files stay with it (the server's expiry clears it if the delete never landed).
    if (vpWarmRead() && vpWarmRead().key === w.key) vpWarmWrite(null);
    return !!(error && error.httpStatus >= 400 && error.httpStatus < 500 && error.httpStatus !== 429);
  });
}
function vpWarmOnce() {
  if (!vpWarmOn() || _cartCheckingOut || _cartSaving || _cartEditing || !cartItems.length || isLocalCheckoutPreview() || cartHasNativeJarLabels()) return Promise.resolve();
  var early = vpArtEarly();
  if (!early || !window.crypto || !window.crypto.subtle) return Promise.resolve();   // a background draft never uploads artwork itself
  var saved;
  try { saved = readSavedCheckout(); } catch (e) { return Promise.resolve(); }
  if (saved) return Promise.resolve();   // this tab already has a checkout (being made, or handed out): the tap resumes that one
  var identity = checkoutCartIdentity();
  if (vpWarmFor(identity) || vpWarm.failed[identity]) return Promise.resolve();
  var items = cartItems.slice(), orderRef = currentOrderRef || 'ORD-0000', source = JSON.stringify(cartItems), ship = vpWarmShip();
  var shipping = JSON.parse(ship);
  var key, files = [];
  function same() {
    return !_cartCheckingOut && !_cartSaving && !_cartEditing && (currentOrderRef || 'ORD-0000') === orderRef && checkoutCartIdentity() === identity &&
      JSON.stringify(cartItems) === source && vpWarmShip() === ship;
  }
  return vpWarmDrop(identity).then(function(dropped) {
    if (!dropped || !same()) return 'stop';
    return Promise.all(items.map(checkoutArtwork));
  }).then(function(artwork) {
    if (artwork === 'stop' || !same()) return 'stop';
    return checkoutFingerprint(identity, artwork, shipping).then(function(fingerprint) {
      key = fingerprint;
      artwork.forEach(function(art, i) {
        [['body', art.artworkOriginalUrl || art.artworkUrl], ['lid', art.lidArtworkOriginalUrl || art.lidArtworkUrl], ['ring', art.ringArtworkOriginalUrl || art.ringArtworkUrl]].forEach(function(part) {
          if (part[1]) files.push({ key: part[0] + '_' + i, item: i, part: part[0], blob: dataUrlToBlob(part[1]) });
        });
      });
      return 'ok';
    });
  }).then(function(step) {
    if (step !== 'ok' || !same()) return same() ? undefined : 'again';
    var pre = {}, missing = [];
    files.forEach(function(file) {
      var ref = early.ready(items[file.item].id, file.part, file.blob, key);
      if (ref) pre[file.key] = ref; else missing.push(file);
    });
    if (missing.length) {
      // Artwork still going up (just added): wait for it, then start over from the cart as it is then. Artwork that
      // isn't going up at all (no real file name, or its upload failed) uploads at the tap as before.
      if (!early.busy(vpArtLines(missing, items))) return undefined;
      return early.settleAll(VP_WARM_ART_WAIT_MS).then(function() { return 'again'; });
    }
    var body = vpCheckoutDraftBody(items, {}, key, orderRef, pre, early.token());
    body.warm = true;
    var lines = vpArtLines(files, items);
    if (lines.length) early.markUsed(lines, key);   // as the tap does: a lost answer still counts
    var done = vpCheckoutRequest('/api/checkout/draft', body, 'Background checkout', 90000).then(function(data) {
      if (!data.draftId || !data.invoiceUrl) throw new Error('The background checkout result was incomplete.');
      var age = Math.min(Math.max(Number(data.ageMs) || 0, 0), VP_DRAFT_SETTLE_MS);
      vpWarmWrite({ v: 1, key: key, cart: identity, orderRef: orderRef, ship: ship, url: checkoutPaymentUrl(data.invoiceUrl), draftId: String(data.draftId), madeAt: Date.now() - age });
      return same() ? undefined : 'again';   // changed meanwhile: the next run takes this one back and makes the right one
    }, function(error) {
      if (error && error.httpStatus >= 400 && error.httpStatus < 500) {
        // Nothing was made: the files are free again, and this exact cart isn't tried again in the background
        // (the tap shows the server's own sentence). Rate limited: a later change may try again.
        early.release(key);
        if (error.vpCode === 'artwork_stale') early.forget(vpArtStaleLines(error, items, files));
        if (error.httpStatus !== 429) vpWarm.failed[identity] = true;
      }
      throw error;   // 5xx or no answer: the tap's own request for this key gets that draft back, or waits for it
    });
    vpWarm.drafting = { cart: identity, request: done.then(null, function() {}) };   // the tap waits for this, answer saved
    return done;
  });
}
// The tap: this tab's background draft for exactly this cart, handed out (null: none). A request for this cart already
// on its way is waited for (the tap's own would only queue behind it on the server). The server then confirms the draft
// is still this cart's and marks it the buyer's (/claim, ~0.1 s), so nothing deletes it later; a discard that got there
// first, a refusal or no answer means no hand-out: the tap makes the checkout the usual way (for this same key the server
// hands back this same draft if it still has it). Sol 10/19 r1: a fire-and-forget beacon could be lost.
function vpWarmHandOff(identity) {
  var d = vpWarm.drafting;
  var wait = d && d.cart === identity ? d.request : Promise.resolve();
  if (d && d.cart === identity) vpWaitStage('draft');
  clearTimeout(vpWarm.timer);
  return wait.then(function() {
    var w = vpWarmFor(identity);
    if (!w) return null;
    vpWarmWrite(null);   // from here on it is the tap's (or nobody's): never discarded by this tab
    return vpCheckoutRequest('/api/checkout/claim', { key: w.key, draftId: w.draftId }, 'Payment service', 8000).then(function(r) {
      return r && r.claimed === true ? w : null;
    }, function() { return null; });
  });
}

// ── Fast payment page (Josh 10/19, same request; theme setting vp_checkout_fast, ?vpfast=) ─────────────────────────
// skip_shop_pay=true on the payment link the tap opens: Shopify opens its checkout at once instead of first bouncing
// through shop.app to look for a Shop Pay account (Shop Pay stays on the page as a button). Measured 10/19: card form
// 1.74 s -> 0.6 s after the tap. Off: the payment link as Shopify makes it.
function vpFastOn() {
  try {
    var o = localStorage.getItem('vp_checkout_fast');
    if (o === 'on' || o === 'off') return o === 'on';
  } catch (e) {}
  return window.VP_CHECKOUT_FAST === 'on';
}
function vpPayUrl(url) {
  if (!vpFastOn()) return url;
  try {
    var u = new URL(url);
    if (/\/invoices\//.test(u.pathname)) u.searchParams.set('skip_shop_pay', 'true');
    return u.href;
  } catch (e) { return url; }
}

function checkoutSim() {
  // One automatic second run when the server calls saved artwork stale (nothing was made): that artwork uploads now.
  return vpCheckoutOnce(false).then(function(r) { return r === VP_ART_RETRY ? vpCheckoutOnce(true) : r; });
}

function vpCheckoutOnce(retried) {
  if (_cartCheckingOut) return Promise.resolve(false);
  if (_cartSaving || _cartEditing) {
    cartCheckoutStatus('Finish saving or cancel your cart edit before continuing to payment.', true);
    return Promise.resolve(false);
  }
  if (isLocalCheckoutPreview()) {
    cartCheckoutStatus('Checkout is unavailable in this local preview: the Drive and Shopify endpoints are not installed. No order was sent.', true);
    return Promise.resolve(false);
  }
  if (!cartItems.length) {
    cartCheckoutStatus('Your cart is empty. Add an item before continuing to payment.', true);
    return Promise.resolve(false);
  }
  if (cartHasNativeJarLabels()) {
    cartCheckoutStatus(nativeJarLabelCheckoutMessage(), true);
    var nativeStatus = document.getElementById('cartCheckoutStatus');
    if (nativeStatus) appendNativeJarLabelLinks(nativeStatus);
    return Promise.resolve(false);
  }

  _cartCheckingOut = true;
  var button = document.querySelector('.cart-btn-checkout');
  var items = cartItems.slice();
  var orderRef = currentOrderRef || 'ORD-0000';
  var identity;
  var source;
  var shipping;
  var saved;
  var key;
  var draftPrepared = false;
  var draftStarted = false;
  var leaving = false;
  var early = null;        // vp-art.js, when on
  var files = [];
  var retryEarly = false;

  function assertUnchanged() {
    if ((currentOrderRef || 'ORD-0000') !== orderRef || checkoutCartIdentity() !== identity || JSON.stringify(cartItems) !== source ||
        JSON.stringify(loadPricing().shipping || {}) !== JSON.stringify(shipping)) {
      throw new Error('Your cart changed. Review the saved items before continuing.');
    }
  }

  // One calm state from the tap: an old message goes, the button says where it is going. Nothing else moves.
  var oldStatus = document.getElementById('cartCheckoutStatus');
  if (oldStatus) { oldStatus.textContent = ''; oldStatus.hidden = true; }
  vpCheckoutBusy(button);
  updateCartBusyState();

  return Promise.resolve().then(function() {
    identity = checkoutCartIdentity();
    source = JSON.stringify(cartItems);
    shipping = JSON.parse(JSON.stringify(loadPricing().shipping || {}));
    saved = readSavedCheckout();
    // Only a saved checkout is asked about (/status); a first checkout goes straight on.
    return vpCheckoutReconcile(saved).then(function(state) {
      if (state === 'paid') return { paid: true };
      saved = readSavedCheckout();
      if (saved && saved.status === 'creating') throw new Error(uncertainCheckoutMessage(saved));
      if (!saveCart()) throw new Error('Browser storage is unavailable. Keep this tab open and restore storage access before trying again.');
      saved = readSavedCheckout();
      // A confirmed payment link for this exact cart: its artwork is already on Shopify, so resume
      // without reloading it from browser storage (which the browser may have cleared).
      if (saved && saved.status === 'ready' && saved.cart === identity && saved.url) {
        var resumeUrl = checkoutPaymentUrl(saved.url);
        writeSavedCheckout(saved);
        leaving = vpCheckoutLeave(resumeUrl, saved.madeAt);
        return { resumed: true };
      }
      // Josh 10/19: the cart already made this exact cart's draft in the background: it is the buyer's now, and the
      // tap leaves at once (or once Shopify is ready for it).
      return vpWarmHandOff(identity).then(function(warm) {
        if (!warm) return Promise.all(items.map(checkoutArtwork));
        saved = { version: 1, key: warm.key, cart: identity, orderRef: orderRef, status: 'ready', url: checkoutPaymentUrl(warm.url), draftId: warm.draftId, madeAt: warm.madeAt };
        writeSavedCheckout(saved);
        leaving = vpCheckoutLeave(saved.url, saved.madeAt);
        return { resumed: true };
      });
    });
  }).then(function(artwork) {
    if (artwork && (artwork.resumed || artwork.paid)) return artwork;
    assertUnchanged();
    return checkoutFingerprint(identity, artwork, shipping).then(function(fingerprint) {
      key = fingerprint;
      assertUnchanged();
      if (saved && saved.status === 'ready' && saved.key === key && saved.cart === identity) {
        var url = checkoutPaymentUrl(saved.url);
        writeSavedCheckout(saved);
        leaving = vpCheckoutLeave(url, saved.madeAt);
        return { resumed: true };
      }
      if (saved) forgetSavedCheckout();
      saved = null;
      files = [];
      artwork.forEach(function(art, i) {
        var suffix = items.length > 1 ? '_Design-' + ('ABCDEFGHIJKLMNOPQRSTUVWXYZ'[i] || String(i + 1)) : '';
        [['body', art.artworkOriginalUrl || art.artworkUrl], ['lid', art.lidArtworkOriginalUrl || art.lidArtworkUrl], ['ring', art.ringArtworkOriginalUrl || art.ringArtworkUrl]].forEach(function(part) {
          if (!part[1]) return;
          var blob = dataUrlToBlob(part[1]);
          var ext = cartUploadExt(blob, items[i], part[0]);
          files.push({ key: part[0] + '_' + i, item: i, part: part[0], name: orderRef + suffix + ({ lid: '_Lid', ring: '_Ring' }[part[0]] || '') + '.' + ext, mimeType: blob.type, size: blob.size, blob: blob });
        });
      });
      // Josh 10/18: artwork already in Shopify Files (uploaded when the design was added to the cart) goes as its
      // file id; a line whose upload is going up right now is waited for (never uploaded a second time on top of
      // it); everything else uploads now as before, side by side with that wait and the price check.
      early = vpArtEarly();
      var lines = vpArtLines(files, items);
      var going = early ? early.inFlight(lines) : [];   // keys of lines going up now (queued ones are taken back: they upload here)
      var pre = {}, now = [], later = [];
      files.forEach(function(file) {
        var ref = early ? early.ready(items[file.item].id, file.part, file.blob, key) : null;
        if (ref) pre[file.key] = ref;
        else if (going.indexOf('item:' + items[file.item].id + ':' + file.part) !== -1) later.push(file);
        else now.push(file);
      });
      var upload = function(list) { return list.length ? vpWaitUpload(vpRawWrapFiles(list).then(function(ready) { return vpCheckoutUpload(orderRef, ready, vpWaitBytes); })) : Promise.resolve({ uploads: {} }); };
      if (now.length || later.length) {
        if (_vpWait) _vpWait.stage = 'upload';   // painted once the uploads below are counted
        if (later.length && _vpWait) {
          var laterLines = vpArtLines(later, items);
          var waiting = _vpWait;
          var readEarly = function() {
            if (_vpWait !== waiting || waiting.poll === -1) return;
            if (typeof early.bytes === 'function') { var b = early.bytes(laterLines); vpWaitBytes('early', b[0], b[1]); }
            waiting.poll = setTimeout(readEarly, 250);
          };
          waiting.poll = setTimeout(readEarly, 0);
        }
      }
      // The price check and the artwork upload run side by side; the draft waits for both. The upload only
      // reaches Shopify's temporary staging storage, so a price the server refuses still stops the checkout
      // before any draft or Shopify File exists.
      return Promise.all([
        vpCheckoutPrice(items),
        upload(now),
        (later.length ? vpWaitUpload(early.settle(lines, VP_ART_SETTLE_MS).then(function() {
          // Its bytes go before its end repaints the button (Sol 10/29 r2: a stale share beside another upload).
          if (_vpWait) { clearTimeout(_vpWait.poll); _vpWait.poll = -1; delete _vpWait.bytes.early; }
        })) : Promise.resolve()).then(function() {
          var rest = [];
          later.forEach(function(file) {
            var ref = early.ready(items[file.item].id, file.part, file.blob, key);
            if (ref) pre[file.key] = ref; else rest.push(file);   // landed: by id; failed or still not there: upload it now
          });
          return upload(rest);
        })
      ]).then(function(done) {
        assertUnchanged();
        return { uploads: Object.assign({}, done[1].uploads, done[2].uploads), pre: pre, artToken: early && Object.keys(pre).length ? early.token() : '' };
      });
    });
  }).then(function(result) {
    if (result.paid) { _cartCheckingOut = false; try { renderCartDrawer(); } catch (e) {} cartCheckoutStatus(VP_CHECKOUT_TEXT.paid, false); return false; }
    if (result.resumed) return true;
    assertUnchanged();
    var draftPayload = vpCheckoutDraftBody(items, result.uploads, key, orderRef, result.pre, result.artToken);
    // The files sent by id belong to this draft from here on (written before the request: a lost answer still counts).
    if (early && result.pre && Object.keys(result.pre).length) {
      early.markUsed(vpArtLines(files.filter(function(f) { return result.pre[f.key]; }), items), key);
    }
    // Persist before the request: a lost response must never trigger a blind retry.
    saved = { version: 1, key: key, cart: identity, orderRef: orderRef, status: 'creating' };
    draftPrepared = true;
    writeSavedCheckout(saved);
    draftStarted = true;
    vpWaitStage('draft');
    return vpCheckoutRequest('/api/checkout/draft', draftPayload, 'Payment service', 90000).then(function(data) {
      if (!data.draftId || !data.invoiceUrl) throw new Error('The checkout result was incomplete.');
      var url = checkoutPaymentUrl(data.invoiceUrl);
      // A draft the server already had (made in the background, Josh 10/19) counts from when it was made.
      saved = { version: 1, key: key, cart: identity, orderRef: orderRef, status: 'ready', url: url, draftId: String(data.draftId),
        madeAt: Date.now() - Math.min(Math.max(Number(data.ageMs) || 0, 0), VP_DRAFT_SETTLE_MS) };
      writeSavedCheckout(saved);
      assertUnchanged();
      leaving = vpCheckoutLeave(url, saved.madeAt);
      return true;
    });
  }).catch(function(error) {
    if (window.console && console.warn) console.warn('[checkout]', (error && error.vpLabel) || '', error);
    var message = error && error.message ? error.message : 'Checkout could not continue.';
    var refused = !!error && error.httpStatus >= 400 && error.httpStatus < 500;   // the server's own sentence
    if (error && /^welcome_/.test(error.vpCode || '')) { vpShip.sig = null; vpShip.welcome = null; }   // show the code's state fresh
    if (early && key) {
      if (error && error.vpCode === 'artwork_stale') {
        // Shopify no longer has that file as saved (or another cart's draft took it): nothing was made. Forget it and
        // run once more, uploading it now; the cart stays in its one calm state.
        early.forget(vpArtStaleLines(error, items, files));
        if (!retried) {
          try { forgetSavedCheckout(); } catch (e) {}
          saved = null;
          retryEarly = true;
          return VP_ART_RETRY;
        }
      } else if (refused) early.release(key);   // nothing was made: the files are free for the next attempt
    }
    if (draftPrepared && !draftStarted) {
      try { forgetSavedCheckout(); } catch(e) {}
      saved = null;
    }
    if (draftStarted && saved && saved.status === 'creating') {
      // Only explicit request rejection is safe to retry without server reconciliation.
      if ([400, 401, 403, 404, 405, 413, 422, 429].indexOf(error.httpStatus) !== -1) {
        try { forgetSavedCheckout(); } catch(e) {}
        if (!/no order was sent/i.test(message)) message += VP_CHECKOUT_TEXT.notSent;
      } else {
        message = uncertainCheckoutMessage(saved);
      }
    } else if (saved && saved.status === 'creating') {
      message = uncertainCheckoutMessage(saved);
    } else if (saved && saved.status === 'ready') {
      message += VP_CHECKOUT_TEXT.keepSaved;
    } else if (refused) {
      if (!/no order was sent/i.test(message)) message += VP_CHECKOUT_TEXT.notSent;
    } else {
      message += VP_CHECKOUT_TEXT.unchanged;
    }
    cartCheckoutStatus(message, true);
    return false;
  }).finally(function() {
    if (leaving) return;   // on the way to Shopify: stay calm until the page is gone (vpCheckoutBack)
    _cartCheckingOut = false;
    if (retryEarly) return;   // the second run starts at once, in the same calm state
    vpWaitStop();
    vpCheckoutAnnounce('');   // the message box says what happened; the hidden line no longer says "Taking you…"
    refreshCartCheckoutUI();
  });
}
